import PropTypes from "prop-types"
import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Modal,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link } from "react-router-dom"
import axios from "axios"
import { getCurrentUser, setPermission, canViewCallLogFeatures } from "../../helpers/Utils.js"
import Paginations from "../../components/Pagination/index.jsx"
import CallLogHistoryDetailModal from "../../components/Dashboard/CallLogHistoryDetailModal"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import FullCalendarCompo from "../../components/Calendar/index"
import { DateRangePicker,Calendar} from "react-date-range"
import { subMonths,subDays  } from "date-fns";
import "react-date-range/dist/styles.css" // main css file
import "react-date-range/dist/theme/default.css" // theme css file
import Loader from "../../components/Loader/loader.js"
import jsPDF from "jspdf"
import "jspdf-autotable"
//i18n
import { withTranslation } from "react-i18next"
import TodayList from "../../components/DailyReport/Today-Report/todayList.js"
import { leadDisplay } from "../../helpers/api_helper.js"

let startdate = ""
let enddate = ""

const Dashboard = props => {
  const isInitialRender = useRef(true)
  const [menu, setMenu] = useState(false)
  const [filterModal, setFilterModal] = useState(false)
  const [bdySoon, setBdySoon] = useState(false)
  const [dayIn, setDayIn] = useState(false)
  const [virtualBoard, setVirtualBoard] = useState(false)
  const [callLogsReports, setCallLogsReports] = useState(false)
  const [staffLeadsTab, setStaffLeadsTab] = useState(false)
  const [attendance, setAttendance] = useState(false)
  const [assigned, setAssigned] = useState(false)
  const [added, setAdded] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showRevenue, setShowRevenue] = useState(false);
  // Add responsive CSS styles
  React.useEffect(() => {
    const style = document.createElement("style")
    style.textContent = `
      @media (max-width: 1200px) {
        .counter-card {
          flex: 1 1 calc(25% - 15px) !important;
          flexWrap: "wrap",
          min-width: 180px !important;
        }
      }

      
      @media (max-width: 480px) {
        .counter-card {
          width: 100% !important;
        }
        .counter-container {
          display: block !important;
          gap: 5px !important;
        }
      }

      .team-analysis-table th {
        text-align: center;
        vertical-align: middle;
        padding: 8px 4px;
        font-weight: 600;
      }

      .team-analysis-table td {
        text-align: center;
        vertical-align: middle;
        padding: 6px 4px;
      }
      .call-log-summary-row:hover {
        background-color: rgba(85, 110, 230, 0.06);
      }
      .expandable-counter {
        cursor: pointer;
        transition: all 0.3s ease;
      }

      .expandable-counter:hover {
        opacity: 0.8;
      }

      .reason-badges {
        width: 100%;
        word-wrap: break-word;
        overflow-wrap: break-word;
        white-space: normal;
      }

      .reason-badges .badge {
        margin: 2px;
        font-size: 10px;
        padding: 3px 6px;
        display: inline-block;
        white-space: nowrap;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .reason-badges .badge:hover {
        max-width: none;
        white-space: normal;
        z-index: 1000;
        position: relative;
      }
    `
    document.head.appendChild(style)

    return () => {
      document.head.removeChild(style)
    }
  }, [])

  // Helper function to safely get localStorage values
  const getLS = key => localStorage.getItem(key) || ""

  // Helper function to build query parameters
  const buildQuery = (base, params = {}) => {
    const baseParams = {
      from_date: startdate,
      to_date: enddate,
      leadholder_id: getLS("leadholder_id"),
      createdBy_id: getLS("createdBy_id"),
      assigned2: getLS("assigned2"),
      isadded: getLS("isadded"),
      ...params,
    }

    const queryString = Object.entries(baseParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")
    return `${base}?${queryString}`
  }

  // Responsive helper function
  const getResponsiveContainerStyle = () => ({
    display: "flex",
    gap: "15px",
    justifyContent: "flex-start",
    alignItems: "stretch",
  })

  const getResponsiveCardStyle = () => ({
    width: "100%",
  })

  // Helper function to render counter cards
  const renderCounter = ({
    to,
    value,
    label,
    subtitle,
    className = "font-size-16 text-uppercase mt-0 text-white-50",
    showPercentage = false,
  }) => {
    // Calculate percentage for specific counters
    const getPercentage = () => {
      if (!showPercentage || !allLeads?.all_leads || allLeads.all_leads === 0) {
        return null
      }
      const percentage = (((value || 0) / allLeads.all_leads) * 100).toFixed(1)
      return percentage
    }

    return (
      <div
        style={getResponsiveCardStyle()}
        className="counter-card" // Add class for CSS media queries
      >
        <Link to={to}>
          <Card className="mini-stat bg-primary text-white">
            <CardBody className="text-center">
              <h2 className="fw-medium fs-1">{allLeads && value}</h2>
              <h5 className={className}>
                {label}
                {subtitle && <span className="text-normal"> {subtitle}</span>}
                {showPercentage && getPercentage() && (
                  <small
                    style={{
                      fontSize: "12px",
                      display: "block",
                      marginTop: "4px",
                    }}
                    className="text-white-75"
                  >
                    ({getPercentage()}%)
                  </small>
                )}
              </h5>
            </CardBody>
          </Card>
        </Link>
      </div>
    )
  }
  const [allLeads, setAllLeads] = useState([])
  const [followUps, setFollowUps] = useState([])
  const [matureStages, setMatureStages] = useState([])
  const [leadLabels, setLeadLabels] = useState([])
  const [leadTags, setLeadTags] = useState([])
  const [staffLeads, setStaffLeads] = useState([])
  const [allPages, setAllPages] = useState([])
  const [reminders, setReminders] = useState({})
  const [counter, setCounter] = useState("")
  const [error, setError] = useState("")
  const [matureError, setMatureError] = useState("")
  const [labelError, setLabelError] = useState("")
  const [followupError, setFollowupError] = useState("")
  const [tagError, setTagError] = useState("")
  const [whatsappBalance, setWhatsappBalance] = useState("")
  const [birthdayLeads, setbirthdayLeads] = useState([])
  const [usersBirthday, setUsersBirthday] = useState([])
  const [totalstaffLeads, setTotalStaffLeads] = useState([])
  const [teamAnalysisData, setTeamAnalysisData] = useState([])
  const [expandedRows, setExpandedRows] = useState({})
    const [callLogs, setCallLogs] = useState([])
  const [callLogsPages, setCallLogsPages] = useState(1)
  const [callLogsCurrentPage, setCallLogsCurrentPage] = useState(1)
  const [callHistoryDetailOpen, setCallHistoryDetailOpen] = useState(false)
  const [selectedCallLogRow, setSelectedCallLogRow] = useState(null)
  const [callHistoryDirectionFilter, setCallHistoryDirectionFilter] =
    useState(null)

  const openCallHistoryModal = (log, direction = null) => {
    setSelectedCallLogRow({
      ...log,
      date:
        (startdate && enddate && `${startdate} → ${enddate}`) || "",
    })
    setCallHistoryDirectionFilter(direction)
    setCallHistoryDetailOpen(true)
  }
  const [databaseSize, setDatabaseSize] = useState([])
  const [loader, setLoader] = useState("")
  const [user, setUser] = useState("")
  const [user2, setUser2] = useState("")
  const [convertedTime, setConvertedTime] = useState("")
  const [customActiveTab, setCustomActiveTab] = useState(1)
  const [todayReport, setTodayReport] = useState([])
  const [showPopup, setShowPopup] = useState(false)
  const [firstLogin, setFirstLogin] = useState(0)
  const [filtersApplied, setFiltersApplied] = useState(false)
  const [branch, setBranch] = useState(
    localStorage.getItem("selectedBranch")
      ? localStorage.getItem("selectedBranch")
      : ""
  )
  const [dateFilter, setDateFilter] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ])
  const [counter2, setCounter2] = useState("")
  const today = new Date()
  const fromDate = new Date(today)
  fromDate.setDate(today.getDate() - 30)

  const toggle = () => {
    setMenu(!menu)
  }

  const formatDate = date => {
    let d = new Date(date)
    let month = (d.getMonth() + 1).toString()
    let day = d.getDate().toString()
    let year = d.getFullYear()
    if (month.length < 2) {
      month = "0" + month
    }
    if (day.length < 2) {
      day = "0" + day
    }
    return [year, month, day].join("-")
  }

  const getTodayReport = () => {
    setLoader(<Loader />)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/today-report?per_page=25`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${getCurrentUser()?.token}`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setLoader("")
          setError(res.data.message)
          setCounter2(res.data.data.from)
          setTodayReport(res.data.data.data)
        } else {
          setLoader("")
          setError(res.data.message)
        }
      })
  }

  const getTeamAnalysisData = (type = "today", isMis = false) => {
    setLoader(<Loader />)
    let url
    if (type !== undefined) {

      setLoading(true)

      const now = new Date()

      // RESET
      startdate = ""
      enddate = ""

      if (type === "today") {
        // DON'T SEND DATE IN URL
        startdate = ""
        enddate = ""
      } else if (type === "month") {
        // CURRENT MONTH DATA

        const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)

        startdate = formatDate(firstDayOfMonth)
        enddate = formatDate(now)
      } else if (type === "custom") {
        startdate = formatDate(dateFilter[0].startDate)
        enddate = formatDate(dateFilter[0].endDate)
      }

      const queryParams = []
      if (startdate && enddate) {
        queryParams.push(`from_date=${startdate}`, `to_date=${enddate}`)
      }
      if (isMis) {
        queryParams.push("mis=1")
      }

      url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/team-analysis${
        queryParams.length ? `?${queryParams.join("&")}` : ""
      }`
    } 
 

    axios
      .get(url, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getCurrentUser()?.token}`,
        },
      })
      .then(function (res) {
        if (res.data.status) {
          setLoader("")
          setTeamAnalysisData(res.data.data)
        } else {
          setLoader("")
          setError(res.data.message)
        }
        setLoading(false)
      })
      .catch(error => {
        // Fallback: Use existing staffLeads data if team-analysis endpoint doesn't exist
        console.log("Team analysis endpoint not found, using staff leads data")
        setLoader("")
        if (staffLeads && staffLeads.length > 0) {
          const fallbackData = staffLeads.map(staff => ({
            id: staff.id,
            name: staff.name,
            role: staff.role,
            total_leads: staff.total || 0,
            new_leads: staff.new || 0,
            untouched_leads: 0, // Will need to be calculated
            no_updation_leads: 0, // Will need to be calculated
            dead_leads: {
              total: staff.dead || 0,
              reasons: [],
            },
            dead_request_leads: {
              total: staff.dead_request || 0,
              reasons: [],
            },
            customers: staff.matured || 0,
            no_repeat_order: 0, // Will need to be calculated
            no_order_since: 0, // Will need to be calculated
            new_business: staff.new_business || 0,
            repeat_business: staff.existing_business || 0,
            followup_leads: {
              total: 0, // Will need to be calculated
              statuses: [],
            },
          }))
          setTeamAnalysisData(fallbackData)
        } else {
          setError("Failed to fetch team analysis data")
        }
        setLoading(false)
      })
  }

  const toggleRowExpansion = (userId, type) => {
    setExpandedRows(prev => ({
      ...prev,
      [`${userId}_${type}`]: !prev[`${userId}_${type}`],
    }))
  }

  const getMisLeadBreakdown = user => {
    if (user.updated_leads_breakdown) {
      return user.updated_leads_breakdown
    }

    return {
      added: user.total_added_leads || 0,
      assigned: user.assigned || 0,
      transferred: user.transfer || 0,
      uploaded: user.uploaded || 0,
    }
  }

  const misLeadBreakdownItems = [
    { key: "added", label: "Added", className: "bg-warning" },
    { key: "uploaded", label: "Uploaded", className: "bg-primary" },
    { key: "assigned", label: "Assigned", className: "bg-info" },
    { key: "transferred", label: "Transferred", className: "bg-secondary" },
  ]
  const getCallLogs = (page = 1) => {
    setLoader(<Loader />)
    let url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
      "company_name"
    )}/call-logs?per_page=25&page=${page}`

    // Add date filters if applied
    if (startdate && enddate) {
      url += `&start_date=${startdate}&end_date=${enddate}`
    }

    axios
      .get(url, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getCurrentUser()?.token}`,
        },
      })
      .then(function (res) {
        if (res.data.status) {
          setLoader("")
          setCallLogs(res.data.data.data)
          setCallLogsPages(res.data.data.last_page)
          setCallLogsCurrentPage(res.data.data.current_page)
        } else {
          setLoader("")
          setError(res.data.message)
        }
      })
      .catch(error => {
        setLoader("")
        setError("Failed to fetch call logs")
      })
  }
  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setCustomActiveTab(tab)
    }
    if (tab == 2) {
      setVirtualBoard(true)
    }
    if (tab == 3) {
      setStaffLeadsTab(true)
    }
    if (tab == 4) {
      setAttendance(true)
    }
    if (tab == 5) {
      getBirthdaySoon()
    }
    if (tab == 6) {
      getUserBirthday()
    }
    if (tab == 7) {
      // Ensure staff leads data is available for fallback
      if (staffLeads.length === 0) {
        getStaffLeads()
      }
      getTeamAnalysisData("today");
    }
    if (tab == 8) {
      //getTodayReport()
      if (staffLeads.length === 0) {
        getStaffLeads()
      }
     getTeamAnalysisData("month", true);
    }
    if (tab == 10) {
      setCallLogsReports(true)
      const today = formatDate(new Date())
      startdate = today
      enddate = today
      getCallLogs()
    }
  }

  const getFilterData = (e, v) => {
    if (customActiveTab == 1) {
      filterData(e, v)
    }
    if (customActiveTab == 3) {
      getStaffLeads(e, v)
      getLeadTags(e, v)
    }
     if (customActiveTab == 10) {
      // Apply date filter for call logs (max last 45 days)
      const minCallLogDate = subDays(new Date(), 45)
      const selectedStart =
        dateFilter[0].startDate < minCallLogDate
          ? minCallLogDate
          : dateFilter[0].startDate
      startdate = formatDate(selectedStart)
      enddate = formatDate(dateFilter[0].endDate)
      getCallLogs(1)
      setFilterModal(false)
    }
    if (customActiveTab == 7) {
      getTeamAnalysisData("custom", false)
      setFilterModal(false)
    }
    if (customActiveTab == 8) {
      getTeamAnalysisData("custom", true)
      setFilterModal(false)
    }
  }
  const getMinDate = () => {
    switch (customActiveTab) {
      case 8:
      case "8":
        return subMonths(new Date(), 2) // last 2 months

      case 3:
      case "3":
        return subDays(new Date(), 45) // last 45 days

      case 10:
      case "10":
        return subDays(new Date(), 45) // call logs: last 45 days only

      default:
        return undefined
    }
  }
  const getLeadTags = (e, value) => {
    setLoader(<Loader />)
    let url
    if (e !== undefined) {
      setLoading(true)
      startdate = formatDate(dateFilter[0].startDate)
      enddate = formatDate(dateFilter[0].endDate)
      url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/dashboard-tag?from_date=${formatDate(
        dateFilter[0].startDate
      )}&to_date=${formatDate(dateFilter[0].endDate)}&leadholder_id=${
        value.leadholder_id
      }&assigned=${assigned ? "1" : ""}`
    } else {
      startdate = ""
      enddate = ""
      url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/dashboard-tag`
    }
    axios
      .get(`${url}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${
            getCurrentUser().token == null ? "" : getCurrentUser().token
          }`,
        },
      })
      .then(function (res) {
        setLoading(false)
        if (res.data.status) {
          setLeadTags(res.data.data)
          setLoader("")
        } else {
          setTagError(res.data.message)
          setLoader("")
        }
      })
  }

  const getStaffLeads = (e, value) => {
    setLoader(<Loader />)
    let url
    if (e !== undefined) {
      setUser(value.leadholder_id)
      setUser2(value.createdBy_id)
      url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/dashboard-user?from_date=${formatDate(
        dateFilter[0].startDate
      )}&to_date=${formatDate(dateFilter[0].endDate)}&leadholder_id=${
        value.leadholder_id
      }&assigned=${assigned ? "1" : ""}`
    } else {
      setUser("")
      setUser2("")
      url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/dashboard-user`
    }
    axios
      .get(`${url}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${
            getCurrentUser().token == null ? "" : getCurrentUser().token
          }`,
        },
      })
      .then(function (res) {
        if (res.data.status) {
          setFilterModal(false)
          setStaffLeads(res.data.data.data)
          setTotalStaffLeads(res.data.data.total)
          setLoader("")
        } else {
        }
        setLoading(false)
      })
  }

  const filterData = (e, value) => {
    setLoader(<Loader />)
    let url
    if (e !== undefined) {
      startdate = formatDate(dateFilter[0].startDate)
      enddate = formatDate(dateFilter[0].endDate)
      setUser(value.leadholder_id)
      setUser2(value.createdBy_id)
      url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/dashboard-data?from_date=${formatDate(
        dateFilter[0].startDate
      )}&to_date=${formatDate(dateFilter[0].endDate)}&leadholder_id=${
        filtersApplied
          ? getCurrentUser()?.role_name === "Executive"
            ? getCurrentUser()?.id
            : value.leadholder_id
          : value.leadholder_id
      }&assigned=${assigned ? "1" : ""}`
    } else {
      setUser("")
      setUser2("")
      url = `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
        "company_name"
      )}/dashboard-data`
      startdate = ""
      enddate = ""
    }
    axios
      .get(`${url}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${
            getCurrentUser().token == null ? "" : getCurrentUser().token
          }`,
        },
      })
      .then(function (res) {
        setLoader("")
        setFilterModal(false)
        setAllLeads(res.data.data?.dashboard)
        setMatureStages(res.data.data?.mature_status)
        setFollowUps(res.data.data?.followup_statuses)
        setLeadLabels(res.data.data?.labels)
        setLoading(false)
        localStorage.setItem("LastUpdated", new Date().getTime())
        localStorage.setItem("DashboardData", JSON.stringify(res.data.data))
        localStorage.setItem(
          "NavCounters",
          JSON.stringify(res.data.data?.all_counters)
        )
        localStorage.setItem(
          "AllSource",
          JSON.stringify(res.data.data?.sources)
        )
        localStorage.setItem(
          "AllFollowups",
          JSON.stringify(res.data.data?.followup_statuses)
        )
        localStorage.setItem(
          "MatureStages",
          JSON.stringify(res.data.data?.mature_status)
        )
        localStorage.setItem("AllLabels", JSON.stringify(res.data.data?.labels))
        localStorage.setItem("AllTags", JSON.stringify(res.data.data?.tag))
        localStorage.setItem("All-User", JSON.stringify(res.data.data?.users))
        localStorage.setItem(
          "AllUsers",
          JSON.stringify(res.data.data?.lead_holders)
        )
        localStorage.setItem(
          "NextFollowup",
          JSON.stringify(res.data.data?.next_followup)
        )
        localStorage.setItem("Noti-Count", res.data.data?.notification_count)
        const convertTimestampToIST = () => {
          const storedTime = new Date(new Date())
          const currentTime = new Date()

          // Calculate the difference in minutes
          const differenceInMilliseconds = currentTime - storedTime
          const differenceInMinutes = Math.floor(
            differenceInMilliseconds / (1000 * 60)
          )
          setConvertedTime(differenceInMinutes)
        }
        convertTimestampToIST()
        setFiltersApplied(true)
        localStorage.setItem("filtersApplied", "true")
      })
  }

  const handleRefreshClick = () => {
    leadDisplay({
      history,
      e: undefined,
      value: {}, // you can pass any default or empty object here
      branch,
      dateFilter,
      setLoader,
      setAllLeads,
      setReminders,
      setMatureStages,
      setFollowUps,
      setLeadLabels,
      setPermission,
      setDatabaseSize,
      setConvertedTime,
      setLoading,
    })
  }

  const handleTeamAnalysisReset = () => {
    // Store current tab to ensure it doesn't change
    const currentTab = customActiveTab

    setFiltersApplied(false)
    clearLeadFilterStorage()
    localStorage.removeItem("filtersApplied")
    setTeamAnalysisData([])
    setExpandedRows({})

    // Restore tab state in case it was changed
    setCustomActiveTab(currentTab)

    // Reload team analysis data
    if (currentTab === 8) {
      getTeamAnalysisData("month", true)
    } else if (currentTab === 7) {
      getTeamAnalysisData("today", false)
    }
  }

  const handleCallLogsReset = () => {
    const today = formatDate(new Date())
    startdate = today
    enddate = today
    setDateFilter([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ])
    getCallLogs(1)
  }

  const getUserBirthday = () => {
    setUsersBirthday([])
    setError("")
    setLoader(<Loader />)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/user-birthday?per_page=${
          localStorage.getItem("PerPage") !== null
            ? localStorage.getItem("PerPage")
            : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setUsersBirthday(res.data.data.data)
          setCounter(res.data.data.from)
          setAllPages(res.data.data)
          setLoader("")
        } else {
          setError(res.data.message)
          setLoader("")
        }
      })
  }

  const getBirthdaySoon = () => {
    setbirthdayLeads([])
    setError("")
    setLoader(<Loader />)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/birthday-soon?per_page=${
          localStorage.getItem("PerPage") !== null
            ? localStorage.getItem("PerPage")
            : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setbirthdayLeads(res.data.data.data)
          setCounter(res.data.data.from)
          setAllPages(res.data.data)
          setLoader("")
        } else {
          setError(res.data.message)
          setLoader("")
        }
      })
  }

  const getBirthday = () => {
    setbirthdayLeads([])
    setError("")
    setLoader(<Loader />)
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/birthday?per_page=${
          localStorage.getItem("PerPage") !== null
            ? localStorage.getItem("PerPage")
            : ""
        }`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setbirthdayLeads(res.data.data.data)
          setCounter(res.data.data.from)
          setAllPages(res.data.data)
          setBdySoon(false)
          setLoader("")
        } else {
          setError(res.data.message)
          setLoader("")
        }
      })
  }

  const paginate = e => {
    setbirthdayLeads([])
    setAllPages([])
    setCounter("")
    setLoader(<Loader />)
    axios
      .get(`${e}`, {
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${
            getCurrentUser().token == null ? "" : getCurrentUser().token
          }`,
        },
      })
      .then(function (res) {
        if (res.data.status) {
          setLoader("")
          setCounter(res.data.data.from)
          setAllPages(res.data.data)
          setbirthdayLeads(res.data.data.data)
        } else {
          setError(res.data.message)
          setLoader("")
        }
      })
  }

  const attendancePunch = e => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/attendance`,
        {
          type: e,
          user_id: getCurrentUser().id,
        },
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          console.log("res", res)
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }

  const getAllUsers = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/get-lead-holders?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          localStorage.setItem("AllUsers", JSON.stringify(res.data.data.data))
        }
        getAllTag()
      })
      .catch(err => {
        getAllTag()
      })
  }

  const getAllSource = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/source?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          localStorage.setItem("AllSource", JSON.stringify(res.data.data.data))
        }
        getAllUser()
      })
      .catch(err => {
        getAllUser()
      })
  }

  const getAllUser = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/user?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          localStorage.setItem("All-User", JSON.stringify(res.data.data.data))
        } else {
        }
      })
  }

  const getAllTag = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/tag?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          localStorage.setItem("AllTags", JSON.stringify(res.data.data.data))
        }
        getAllLabel()
      })
      .catch(err => {
        getAllLabel()
      })
  }

  const getAllLabel = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/label?per_page=5000`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          localStorage.setItem("AllLabels", JSON.stringify(res.data.data.data))
        }
        getAllSource()
      })
      .catch(err => {
        getAllSource()
      })
  }

  const exportPDF = () => {
    const unit = "pt"
    const size = "A4" // Use A1, A2, A3 or A4
    const orientation = "landscape" // portrait or landscape

    const marginLeft = 40
    const doc = new jsPDF(orientation, unit, size)

    doc.setFontSize(15)

    const title = "Staff Leads"
    const headers = [
      [
        "#",
        "Name",
        "Total",
        "Old",
        "Today",
        "Due",
        "Updated",
        "Updation",
        "New",
        "Assigned",
        "Matured",
        "Dead",
        "Request",
        "Business",
      ],
    ]

    const staticData = [
      [
        "Total",
        "",
        totalstaffLeads.all_total,
        totalstaffLeads.old_total,
        totalstaffLeads.today_total,
        totalstaffLeads.due_total,
        totalstaffLeads.done_total,
        totalstaffLeads.total_updation,
        totalstaffLeads.new_total,
        totalstaffLeads.assigned_total,
        totalstaffLeads.matured_total,
        totalstaffLeads.dead_total,
        totalstaffLeads.dead_request_total,
        totalstaffLeads.business_total,
      ],
    ]

    const data =
      staffLeads && staffLeads.length > 0
        ? staffLeads
            .map((item, i) => [
              i + 1,
              item.name,
              item.total,
              item.old,
              item.today,
              item.due,
              item.done,
              item.updation,
              item.new,
              item.assigned,
              item.matured,
              item.dead,
              item.dead_request,
              item.business,
            ])
            .concat(staticData)
        : "No data Found"

    let content = {
      startY: 50,
      head: headers,
      body: data,
    }

    doc.text(title, marginLeft, 40)
    doc.autoTable(content)
    doc.save("Staffleads.pdf")
  }

  const exportTeamAnalysisPDF = () => {
    const unit = "pt"
    const size = "A4"
    const orientation = "landscape"

    const marginLeft = 40
    const doc = new jsPDF(orientation, unit, size)

    doc.setFontSize(15)

    const title = "Team Analysis - Lead Counters"
    const headers = [
      [
        "#",
        "Username",
        "Total",
        "New",
        "Untouched",
        "Followup",
        "No Updation",
        "Dead",
        "Dead Request",
        "Customers",
        "No Repeat Order",
        "No Order",
        "Business",
      ],
    ]

    const data =
      teamAnalysisData && teamAnalysisData.length > 0
        ? teamAnalysisData.map((user, i) => [
            i + 1,
            user.name,
            user.total_leads || 0,
            `${user.new_leads || 0} (${
              user.total_leads > 0
                ? (((user.new_leads || 0) / user.total_leads) * 100).toFixed(1)
                : 0
            }%)`,
            `${user.untouched_leads || 0} (${
              user.total_leads > 0
                ? (
                    ((user.untouched_leads || 0) / user.total_leads) *
                    100
                  ).toFixed(1)
                : 0
            }%)`,
            `${user.followup_leads?.total || 0} (${
              user.total_leads > 0
                ? (
                    ((user.followup_leads?.total || 0) / user.total_leads) *
                    100
                  ).toFixed(1)
                : 0
            }%)`,
            `${user.no_updation_leads || 0} (${
              user.total_leads > 0
                ? (
                    ((user.no_updation_leads || 0) / user.total_leads) *
                    100
                  ).toFixed(1)
                : 0
            }%)`,
            `${user.dead_leads?.total || 0} (${
              user.total_leads > 0
                ? (
                    ((user.dead_leads?.total || 0) / user.total_leads) *
                    100
                  ).toFixed(1)
                : 0
            }%)`,
            `${user.dead_request_leads?.total || 0} (${
              user.total_leads > 0
                ? (
                    ((user.dead_request_leads?.total || 0) / user.total_leads) *
                    100
                  ).toFixed(1)
                : 0
            }%)`,
            `${user.customers || 0} (${
              user.total_leads > 0
                ? (((user.customers || 0) / user.total_leads) * 100).toFixed(1)
                : 0
            }%)`,
            user.no_repeat_order || 0,
            user.no_order_since || 0,
            `Rs.${(
              (user.new_business || 0) + (user.repeat_business || 0)
            ).toLocaleString()} (New: Rs.${(
              user.new_business || 0
            ).toLocaleString()}, Repeat: Rs.${(
              user.repeat_business || 0
            ).toLocaleString()})`,
          ])
        : [["No data available"]]

    let content = {
      startY: 50,
      head: headers,
      body: data,
      styles: { fontSize: 8 },
      headStyles: { fontSize: 9, fillColor: [41, 128, 185] },
    }

    doc.text(title, marginLeft, 40)
    doc.autoTable(content)
    doc.save("Team-Analysis.pdf")
  }

  useEffect(() => {
    const close = e => {
      if (e.key === "Escape") {
        setFilterModal(false)
      }
    }
    window.addEventListener("keydown", close)
    return () => window.removeEventListener("keydown", close)
  }, [])

  useEffect(() => {
    setStaffLeadsTab(false)
    const storedData = localStorage.getItem("DashboardData")
    const storedTimestamp = localStorage.getItem("LastUpdated")
      ? localStorage.getItem("LastUpdated")
      : 0
    const currentTime = new Date()
    const timeDiff = (currentTime - parseInt(storedTimestamp, 10)) / (1000 * 60)
    if (storedData !== "" && timeDiff < 30) {
      setAllLeads(JSON.parse(localStorage.getItem("DashboardData")).dashboard)
      setMatureStages(
        JSON.parse(localStorage.getItem("DashboardData")).mature_status
      )
      setFollowUps(
        JSON.parse(localStorage.getItem("DashboardData")).followup_statuses
      )
      setLeadLabels(JSON.parse(localStorage.getItem("DashboardData")).labels)
      setDatabaseSize(
        JSON.parse(localStorage.getItem("DashboardData")).db_usage
      )
      setReminders(JSON.parse(localStorage.getItem("DashboardData")).reminders)
      setConvertedTime(Math.round(timeDiff))
    } else {
      handleRefreshClick()
    }
  }, [])

  useEffect(() => {
    // This block will run on every render
    if (isInitialRender.current) {
      // Code for the initial render (skipping function calls)
      isInitialRender.current = false
    } else {
      // Code for subsequent renders (where you want to call the functions)
      getLeadTags()
      getStaffLeads()
    }
  }, [staffLeadsTab])

  useEffect(() => {
    const storedFlag = localStorage.getItem("filtersApplied")

    if (storedFlag === "true") {
      setFiltersApplied(true)

      const leadholder_id =
        getCurrentUser()?.role_name === "Executive"
          ? getCurrentUser()?.id
          : user

      if (leadholder_id && filtersApplied) {
        localStorage.setItem("leadholder_id", leadholder_id)
      }
      if (user2) {
        localStorage.setItem("createdBy_id", user2)
      }
      if (assigned) {
        localStorage.setItem("assigned2", assigned ? "1" : "")
      }
      if (added) {
        localStorage.setItem("isadded", added ? "1" : "")
      }
    }
  }, [user, user2, assigned, added])

  const showFirstLogin = () => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/update-first-login`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${getCurrentUser()?.token}`,
          },
          params: {
            is_first_login: 0,
          },
        }
      )
      .then(res => {
        if (res.data.data) {
          setFirstLogin(res.data.data?.is_first_login)
        }
      })
  }

  const handleExploreClick = () => {
    setShowPopup(false)
    showFirstLogin()
    window.location.href = "/host-domain" // Redirects to settings page
  }

  const handleNotInterestedClick = () => {
    setShowPopup(false)
    showFirstLogin()
  }

  const clearLeadFilterStorage = () => {
    localStorage.removeItem("leadholder_id")
    localStorage.removeItem("createdBy_id")
    localStorage.removeItem("assigned2")
    localStorage.removeItem("isadded")

    // Reset date variables
    startdate = ""
    enddate = ""
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <div
            className={`page-title-box ${
              getCurrentUser()?.expiry_message !== null ? "margin-top-24" : ""
            }`}
            style={{ marginBottom: "0px !important" }}
          >
            {getCurrentUser()?.user_schemes.length > 0 ? (
              <div className="">
                {getCurrentUser()?.user_schemes?.map(item => (
                  <>
                    <span className="text-white fs-5 bg-warning p-2">
                      <span style={{ fontWeight: "500" }}>{item.message}</span>.
                      - Expiring on
                      <span style={{ fontWeight: "500" }}>
                        {" "}
                        {item.end_date}
                      </span>
                    </span>
                    <br />
                    <br />
                  </>
                ))}
              </div>
            ) : (
              ""
            )}
            <Row className="align-items-center">
              <Col md={3}>
                <h6 className="page-title">Dashboard</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to KlikCRM Dashboard
                  </li>
                </ol>
              </Col>
              <Col md={9}>
                <h6 className="card-title  float-end">
                  {getCurrentUser()?.role_name == "Administrator" ? (
                    <span
                      className="fw-bold btn btn-secondary me-2"
                      style={{ pointerEvents: "none" }}
                    >
                      Database Usage {databaseSize?.used_size}/
                      {databaseSize?.total_size}
                    </span>
                  ) : (
                    <span
                      className="fw-bold btn btn-secondary me-2"
                      style={{ pointerEvents: "none" }}
                    >
                      Monthly Target:{" "}
                      {getCurrentUser()?.monthly_business_target}
                    </span>
                  )}
                  {customActiveTab == "3" || customActiveTab == "7" ? (
                    <button
                      className="btn btn-primary submit__button me-2"
                      type="button"
                      onClick={() =>
                        customActiveTab == "3"
                          ? exportPDF()
                          : exportTeamAnalysisPDF()
                      }
                    >
                      Export
                    </button>
                  ) : (
                    ""
                  )}
                  {customActiveTab == "1" ||
                  customActiveTab == "3" ||
                  customActiveTab == "7" ||
                  customActiveTab == "8" ||
                  customActiveTab == "10" ? (
                    <>
                      {customActiveTab == "3" ||
                      customActiveTab == "7" ||
                      customActiveTab == "8" ||
                      customActiveTab == "10" ? (
                        <>
                          {startdate !== "" ? (
                            <span className="me-2 badge bg-secondary text-dark fs-6 fw-bold">
                              From: {startdate} - To: {enddate}
                            </span>
                          ) : (
                            ""
                          )}
                          <button
                            className="btn btn-primary submit__button me-2"
                            type="button"
                            onClick={() => {
                              setFilterModal(true)
                            }}
                          >
                            <i className="fas fa-filter me-2"></i>
                            Filter
                          </button>
                          {startdate !== "" ? (
                            <button
                              className="btn btn-primary submit__button"
                              type="button"
                              onClick={() => {
                                if (customActiveTab == "10") {
                                  handleCallLogsReset()
                                } else {
                                  handleRefreshClick
                                  window.location.reload()
                                }
                              }}
                            >
                              <i className="fa me-2" aria-hidden="true">
                                &#xf021;
                              </i>
                              Reset Filters
                            </button>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        <>
                          <span
                            className="fw-bold btn btn-secondary me-2"
                            style={{ pointerEvents: "none" }}
                          >
                            Last Updated {convertedTime} mins ago
                          </span>
                          <button
                            className="btn btn-primary submit__button"
                            type="button"
                            onClick={handleRefreshClick}
                          >
                            <i className="fa" aria-hidden="true">
                              &#xf021;
                            </i>
                          </button>
                        </>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {customActiveTab == "5" ? (
                    <>
                      <button
                        className="btn btn-primary submit__button me-2"
                        type="button"
                        onClick={() => getBirthday()}
                      >
                        Birthday
                      </button>
                    </>
                  ) : (
                    ""
                  )}
                </h6>
              </Col>
            </Row>
          </div>
          <Nav tabs>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === 1 })}
                onClick={() => {
                  toggleCustom(1)
                }}
              >
                {" "}
                Analytics
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === 7 })}
                onClick={() => {
                  toggleCustom(7)
                }}
              >
                {""}
                Team Analysis
              </NavLink>
            </NavItem>
            
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === 3 })}
                onClick={() => {
                  toggleCustom(3)
                }}
              >
                {" "}
                Virtual Board
              </NavLink>
            </NavItem>
            {canViewCallLogFeatures() && (
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: customActiveTab === 10 })}
                  onClick={() => {
                    toggleCustom(10)
                  }}
                >
                  {" "}
                  Call Logs
                </NavLink>
              </NavItem>
            )}
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({ active: customActiveTab === 4 })}
                onClick={() => {
                  toggleCustom(4)
                }}
              >
                {" "}
                Attendance
              </NavLink>
            </NavItem>
            
          </Nav>
          <TabContent activeTab={customActiveTab} className="pt-3">
            <TabPane tabId={1}>
              {loader ? (
                loader
              ) : (
                <>
                  <Row className="mb-4">
                    <Col md={8}>
                      <Card className="h-100">
                        <CardBody>
                          <h2 className="card-title mb-4 border-bottom pb-2">
                           <i>All time data</i>
                            <button
                              className="btn btn-primary submit__button ms-2"
                              type="button"
                              onClick={() => {
                                setFilterModal(true)
                                setFiltersApplied(true)
                              }}
                            >
                              <i className="fas fa-filter me-2"></i>
                              Filter
                            </button>
                            {startdate !== "" && filtersApplied ? (
                              <>
                                <button
                                  className="ms-2 btn btn-primary submit__button"
                                  type="button"
                                  onClick={() => {
                                    // Handle Team Analysis tab differently to preserve tab
                                    if (customActiveTab === "7") {
                                      handleTeamAnalysisReset()
                                    } else {
                                      setFiltersApplied(false)
                                      clearLeadFilterStorage()
                                      localStorage.removeItem("filtersApplied")
                                      handleRefreshClick().then(() => {
                                        setFiltersApplied(false)
                                      })
                                    }
                                  }}
                                >
                                  <i className="fa me-2" aria-hidden="true">
                                    &#xf021;
                                  </i>
                                  Reset Filters
                                </button>
                                <span className="ms-2 badge bg-secondary text-dark fs-6 fw-bold">
                                  From: {startdate} - To: {enddate}
                                </span>
                              </>
                            ) : (
                              ""
                            )}
                          </h2>
                          <div
                            style={getResponsiveContainerStyle()}
                            className="counter-container"
                          >
                            {renderCounter({
                              to: buildQuery("/leads", { id: "" }),
                              value: allLeads.all_leads,
                              label: "All Leads",
                            })}

                            {renderCounter({
                              to: buildQuery("/leads", { type: "new" }),
                              value: allLeads.new,
                              label: "New",
                              showPercentage: true,
                            })}

                            {renderCounter({
                              to: buildQuery("/leads", {
                                type: "untouched",
                                assigned: 1,
                                no_followup: 1,
                              }),
                              value: allLeads.untouched,
                              label: "Untouched",
                              showPercentage: true,
                            })}

                            {renderCounter({
                              to: buildQuery("/leads", { type: "dead" }),
                              value: allLeads.dead,
                              label: "Dead",
                              showPercentage: true,
                            })}

                            {renderCounter({
                              to: buildQuery("/leads", {
                                type: "dead_request",
                              }),
                              value: allLeads.dead_request,
                              label: "Dead Request",
                              showPercentage: true,
                            })}
                          </div>
                          <div
                            style={getResponsiveContainerStyle()}
                            className="counter-container"
                          >
                            {renderCounter({
                              to: buildQuery("/transfer-request", {
                                from: startdate,
                                to: enddate,
                                leadholder_id: getLS("leadholder_id"),
                                createdBy_id: getLS("createdBy_id"),
                                assigned2: getLS("assigned2"),
                                isadded: getLS("isadded"),
                              }),
                              value: allLeads.transfer_request,
                              label: "Transfer Request",
                              showPercentage: true,
                            })}

                            {renderCounter({
                              to:
                                getCurrentUser()?.crm_permission == "1" ||
                                getCurrentUser()?.crmpro_permission == "1" ||
                                getCurrentUser()?.crmpronew_permission == "1"
                                  ? buildQuery("/customers", {})
                                  : buildQuery("/leads", { type: "matured" }),
                              value: allLeads.matured,
                              label:
                                getCurrentUser()?.crm_permission == "1" ||
                                getCurrentUser()?.crmpro_permission == "1" ||
                                getCurrentUser()?.crmpronew_permission == "1"
                                  ? "Customers"
                                  : "Matured Leads",
                              showPercentage: true,
                            })}

                            {renderCounter({
                              to: `/customers?single_order_only=1&from_date=${startdate}&to_date=${enddate}&leadholder_id=${getLS(
                                "leadholder_id"
                              )}&createdBy_id=${getLS(
                                "createdBy_id"
                              )}&assigned2=${getLS(
                                "assigned2"
                              )}&isadded=${getLS("isadded")}`,
                              value: allLeads.no_repeat_order,
                              label: "No Repeat Order",
                              className:
                                "font-size-16 mt-0 text-uppercase text-white-50",
                            })}

                            {renderCounter({
                              to: `/customers?no_order_since=${formatDate(
                                fromDate
                              )}&from_date=${startdate}&to_date=${enddate}&leadholder_id=${getLS(
                                "leadholder_id"
                              )}&createdBy_id=${getLS(
                                "createdBy_id"
                              )}&assigned2=${getLS(
                                "assigned2"
                              )}&isadded=${getLS("isadded")}`,
                              value: allLeads.no_order_since,
                              label: "No Order",
                              subtitle: "(Since 30 days)",
                              className:
                                "font-size-16 mt-0 text-uppercase text-white-50",
                            })}

                            {renderCounter({
                              to: buildQuery("/leads", {
                                no_updation: 1,
                                no_updation_from_date: formatDate(fromDate),
                              }),
                              value: allLeads.no_updations,
                              label: "No Updation",
                              subtitle: "(Since 30 days)",
                              className:
                                "font-size-16 mt-0 text-uppercase text-white-50",
                            })}

                            {loader}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card className="">
                        <CardBody>
                          <div className="fs-h3 d-flex align-items-center">
                            <span className="fw-bold fs-5">
                              Total Business
                            </span>

                            <i
                              className="fa fa-info-circle ms-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => setShowRevenue(!showRevenue)}
                            ></i>

                            {showRevenue && (
                              <>
                                <span className="mx-2">:</span>
                                <span className="fs-5">
                                  {allLeads?.total_revenue}
                                </span>
                              </>
                            )}

                            {loader}
                          </div>
                        </CardBody>
                      </Card>
                      <Card className="">
                        <CardBody>
                          <div
                            className="accordion accordion-flush"
                            id="accordionFlushExample"
                          >
                            {getCurrentUser()?.crm_permission === 1 ||
                            getCurrentUser()?.crmpro_permission === 1 ||
                            getCurrentUser()?.crmpronew_permission === 1 ? (
                              <>
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseOne"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseOne"
                                    >
                                      Reminders
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseOne"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion-body">
                                      <h3 className="mx-2">
                                        <Link
                                          to={`/leads?type=matured&mature_status_options=reorder&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                            localStorage.getItem(
                                              "leadholder_id"
                                            ) || ""
                                          }&createdBy_id=${
                                            localStorage.getItem(
                                              "createdBy_id"
                                            ) || ""
                                          }&assigned2=${
                                            localStorage.getItem("assigned2") ||
                                            ""
                                          }&isadded=${
                                            localStorage.getItem("isadded") ||
                                            ""
                                          }`}
                                          className="pt-2 p-2 badge bg-primary"
                                          // style={{ backgroundColor: "orange" }}
                                        >
                                          Re Order - {reminders?.reorder}
                                        </Link>
                                      </h3>
                                      <h3 className="mx-2">
                                        <Link
                                          to={`/leads?type=matured&mature_status_options=payment_reminder&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                            localStorage.getItem(
                                              "leadholder_id"
                                            ) || ""
                                          }&createdBy_id=${
                                            localStorage.getItem(
                                              "createdBy_id"
                                            ) || ""
                                          }&assigned2=${
                                            localStorage.getItem("assigned2") ||
                                            ""
                                          }&isadded=${
                                            localStorage.getItem("isadded") ||
                                            ""
                                          }`}
                                          className="pt-2 p-2 badge bg-primary"
                                          // style={{ backgroundColor: "orange" }}
                                        >
                                          Payment Reminder -{" "}
                                          {reminders?.payment_reminder}
                                        </Link>
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseTwo"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseTwo"
                                >
                                  Followup Stages
                                </button>
                              </h2>
                              <div
                                id="flush-collapseTwo"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body">
                                  <h3 className="mx-2">
                                    <Link
                                      to={`/leads?type=followup&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                        localStorage.getItem("leadholder_id") ||
                                        ""
                                      }&createdBy_id=${
                                        localStorage.getItem("createdBy_id") ||
                                        ""
                                      }&assigned2=${
                                        localStorage.getItem("assigned2") || ""
                                      }&isadded=${
                                        localStorage.getItem("isadded") || ""
                                      }`}
                                      className="pt-2 p-2 badge bg-primary"
                                      // style={{ backgroundColor: "orange" }}
                                    >
                                      All FollowUps -{" "}
                                      {allLeads && allLeads.followup}
                                    </Link>
                                  </h3>
                                  {followUps &&
                                    followUps.map((item, i) => (
                                      <h3 className="mx-2" key={i}>
                                        <Link
                                          to={`/leads?followup_status_id=${
                                            item.id
                                          }&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                            localStorage.getItem(
                                              "leadholder_id"
                                            ) || ""
                                          }&createdBy_id=${
                                            localStorage.getItem(
                                              "createdBy_id"
                                            ) || ""
                                          }&assigned2=${
                                            localStorage.getItem("assigned2") ||
                                            ""
                                          }&isadded=${
                                            localStorage.getItem("isadded") ||
                                            ""
                                          }`}
                                          className="pt-2 p-2 badge"
                                          style={{ backgroundColor: "orange" }}
                                        >
                                          {`${item.name} - ${item.count}`}
                                        </Link>
                                      </h3>
                                    ))}
                                  {followupError ? (
                                    <span
                                      className="text-danger mt-3 d-table m-auto"
                                      role="alert"
                                    >
                                      {followupError}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                            {getCurrentUser()?.crm_permission === 1 ||
                            getCurrentUser()?.crmpro_permission === 1 ||
                            getCurrentUser()?.crmpronew_permission === 1 ? (
                              <>
                                <div className="accordion-item">
                                  <h2 className="accordion-header">
                                    <button
                                      className="accordion-button collapsed"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#flush-collapseThree"
                                      aria-expanded="false"
                                      aria-controls="flush-collapseThree"
                                    >
                                      Mature Stages
                                    </button>
                                  </h2>
                                  <div
                                    id="flush-collapseThree"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#accordionFlushExample"
                                  >
                                    <div className="accordion-body">
                                      <h3 className="mx-2">
                                        <Link
                                          to={`/leads?type=matured&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                            localStorage.getItem(
                                              "leadholder_id"
                                            ) || ""
                                          }&createdBy_id=${
                                            localStorage.getItem(
                                              "createdBy_id"
                                            ) || ""
                                          }&assigned2=${
                                            localStorage.getItem("assigned2") ||
                                            ""
                                          }&isadded=${
                                            localStorage.getItem("isadded") ||
                                            ""
                                          }`}
                                          className="pt-2 p-2 badge bg-primary"
                                          // style={{ backgroundColor: "orange" }}
                                        >
                                          All Customers -{" "}
                                          {allLeads && allLeads.matured}
                                        </Link>
                                      </h3>
                                      {matureStages &&
                                        matureStages
                                          .filter(
                                            item =>
                                              item.name !== "Wrong Mature ID" &&
                                              item.name !== "Others"
                                          )
                                          .map((item, i) => (
                                            <h3 className="mx-2" key={i}>
                                              <Link
                                                to={`/leads?mature_status_id=${
                                                  item.id
                                                }&type=matured&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                                  localStorage.getItem(
                                                    "leadholder_id"
                                                  ) || ""
                                                }&createdBy_id=${
                                                  localStorage.getItem(
                                                    "createdBy_id"
                                                  ) || ""
                                                }&assigned2=${
                                                  localStorage.getItem(
                                                    "assigned2"
                                                  ) || ""
                                                }&isadded=${
                                                  localStorage.getItem(
                                                    "isadded"
                                                  ) || ""
                                                }`}
                                                className="pt-2 p-2 badge"
                                                style={{
                                                  backgroundColor: "orange",
                                                }}
                                              >
                                                {item.name} - {item.lead_count}
                                              </Link>
                                            </h3>
                                          ))}
                                      {matureStages &&
                                        matureStages
                                          .filter(
                                            item =>
                                              item.name === "Wrong Mature ID"
                                          )
                                          .map((item, i) => (
                                            <h3
                                              className="mx-2"
                                              key={`extra-${i}`}
                                            >
                                              <Link
                                                to={`/leads?mature_status_id=${
                                                  item.id
                                                }&type=matured&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                                  localStorage.getItem(
                                                    "leadholder_id"
                                                  ) || ""
                                                }&createdBy_id=${
                                                  localStorage.getItem(
                                                    "createdBy_id"
                                                  ) || ""
                                                }&assigned2=${
                                                  localStorage.getItem(
                                                    "assigned2"
                                                  ) || ""
                                                }&isadded=${
                                                  localStorage.getItem(
                                                    "isadded"
                                                  ) || ""
                                                }&mature_type=wrong`}
                                                className="pt-2 p-2 badge"
                                                style={{
                                                  backgroundColor: "orange",
                                                }}
                                              >
                                                {item.name} - {item.lead_count}
                                              </Link>
                                            </h3>
                                          ))}
                                      {matureStages &&
                                        matureStages
                                          .filter(
                                            item => item.name === "Others"
                                          )
                                          .map((item, i) => (
                                            <h3
                                              className="mx-2"
                                              key={`extra-${i}`}
                                            >
                                              <Link
                                                to={`/leads?mature_status_id=${
                                                  item.id
                                                }&type=matured&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                                  localStorage.getItem(
                                                    "leadholder_id"
                                                  ) || ""
                                                }&createdBy_id=${
                                                  localStorage.getItem(
                                                    "createdBy_id"
                                                  ) || ""
                                                }&assigned2=${
                                                  localStorage.getItem(
                                                    "assigned2"
                                                  ) || ""
                                                }&isadded=${
                                                  localStorage.getItem(
                                                    "isadded"
                                                  ) || ""
                                                }&mature_type=others`}
                                                className="pt-2 p-2 badge"
                                                style={{
                                                  backgroundColor: "orange",
                                                }}
                                              >
                                                {item.name} - {item.lead_count}
                                              </Link>
                                            </h3>
                                          ))}
                                      {matureError ? (
                                        <span
                                          className="text-danger mt-3 d-table m-auto"
                                          role="alert"
                                        >
                                          {matureError}
                                        </span>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}

                            <div className="accordion-item">
                              <h2 className="accordion-header">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseFour"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseFour"
                                >
                                  Lead Labels
                                </button>
                              </h2>
                              <div
                                id="flush-collapseFour"
                                className="accordion-collapse collapse"
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body">
                                  {leadLabels &&
                                    leadLabels.map((item, i) => (
                                      <h3 className="mx-2" key={i}>
                                        <Link
                                          to={`/leads?lead_label_id=${
                                            item.id
                                          }&from_date=${startdate}&to_date=${enddate}&leadholder_id=${
                                            localStorage.getItem(
                                              "leadholder_id"
                                            ) || ""
                                          }&createdBy_id=${
                                            localStorage.getItem(
                                              "createdBy_id"
                                            ) || ""
                                          }&assigned2=${
                                            localStorage.getItem("assigned2") ||
                                            ""
                                          }&isadded=${
                                            localStorage.getItem("isadded") ||
                                            ""
                                          }`}
                                          className="pt-2 p-2 badge"
                                          style={{ backgroundColor: "orange" }}
                                        >
                                          {item.name} - {item.total}
                                        </Link>
                                      </h3>
                                    ))}
                                  {labelError ? (
                                    <span
                                      className="text-danger mt-3 d-table m-auto"
                                      role="alert"
                                    >
                                      {labelError}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </>
              )}
            </TabPane>
            <TabPane tabId={2}>
              <Row className="mb-4">
                <Col xl={9}>
                  <Card className="h-100">
                    <CardBody>
                      <h4 className="card-title mb-4">Monthly Leads</h4>
                      <Row>
                        <Col lg={12}>
                          <div>{virtualBoard ? <LineAreaChart /> : ""}</div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>

                <Col xl={3}>
                  <Card className="h-100">
                    <CardBody>
                      <h4 className="card-title mb-4">Followup Stages</h4>
                      <div className="cleafix">
                        <p className="float-start">Detailed Report</p>
                        <h5 className="font-18 text-end">$4230</h5>
                      </div>
                      <div id="ct-donut" className="ct-chart wid pt-5">
                        {virtualBoard ? <Salesdonut /> : ""}
                      </div>
                      <div className="mt-4">
                        <table className="table mb-0">
                          <tbody>
                            <tr>
                              <td>
                                <span className="badge bg-primary">Desk</span>
                              </td>
                              <td>Desktop</td>
                              <td className="text-end">54.5%</td>
                            </tr>
                            <tr>
                              <td>
                                <span className="badge bg-success">Mob</span>
                              </td>
                              <td>Mobile</td>
                              <td className="text-end">28.0%</td>
                            </tr>
                            <tr>
                              <td>
                                <span className="badge bg-warning">Tab</span>
                              </td>
                              <td>Tablets</td>
                              <td className="text-end">17.5%</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={3}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-5">Single Day Report <i>(day-wise data available for the past 45 days)</i></h4>
                      <div
                        style={{
                          marginTop: "-47px",
                          position: "relative",
                        }}
                        className="table-responsive"
                      >
                        <table className="table table-centered table-nowrap mb-0 dash-table">
                          <thead>
                            <tr>
                              <th colSpan="3" className="bg-transparent"></th>
                              <th
                                colSpan="3"
                                style={{ border: "1px solid" }}
                                className="text-center"
                              >
                                <small>Refreshed at 12:04 AM</small> <br />{" "}
                                Followups
                              </th>
                            </tr>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Login</th>
                              <th scope="col">Name</th>
                              <th
                                scope="col"
                                style={{
                                  border: "1px solid",
                                  borderRight: "none",
                                }}
                              >
                                Total
                              </th>
                              <th
                                scope="col"
                                style={{
                                  border: "1px solid",
                                  borderLeft: "none",
                                  borderRight: "none",
                                }}
                              >
                                Miss
                              </th>
                              <th
                                scope="col"
                                style={{
                                  border: "1px solid",
                                  borderLeft: "none",
                                }}
                              >
                                Today
                              </th>
                              <th scope="col">Due</th>
                              <th scope="col">Leads</th>
                              <th scope="col">Updation</th>
                              <th scope="col">New</th>
                              <th scope="col">Assigned</th>
                              <th scope="col">Transferred</th>
                              <th scope="col">Dead</th>
                              <th scope="col">Request</th>
                              <th scope="col">Matured</th>
                              <th scope="col">Repeat</th>
                            </tr>
                          </thead>
                          <tbody>
                            {staffLeads &&
                              staffLeads.map((item, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>
                                    {item.live === "yes" || getCurrentUser()?.id == item.id ? (
                                      <span style={{ display: "flex", alignItems: "center" }}>
                                        <span
                                          className="text-success"
                                          style={{
                                            fontSize: "40px",
                                            padding: "0px 6px 0px 6px",
                                          }}
                                        >
                                          •
                                        </span>
                                        <span>({item.loginCount || 0})</span>
                                      </span>
                                    ) : (
                                      <span style={{ display: "flex", alignItems: "center" }}>
                                        <span
                                          className="text-danger"
                                          style={{
                                            fontSize: "40px",
                                            padding: "0px 6px 0px 6px",
                                          }}
                                        >
                                          •
                                        </span>
                                        <span>({item.loginCount || 0})</span>
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    <Link
                                      className="text-info"
                                      to={`/leads?leadholder_id=${item.id}`}
                                    >
                                      {item.name}
                                    </Link>{" "}
                                    <br />
                                    {item.role !== null ? (
                                      <>
                                        <span className="text-muted">
                                          ({item.role})
                                        </span>{" "}
                                        <br />
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <span className="text-muted">
                                      {item.last_seen_at}
                                    </span>
                                  </td>
                                  <td style={{ background: "silver" }}>
                                    {item.total}
                                  </td>
                                  <td style={{ background: "white" }}>
                                    {item.old}
                                  </td>
                                  <td style={{ background: "silver" }}>
                                    {item.today}
                                  </td>
                                  <td style={{ background: "white" }}>
                                    {" "}
                                    <Link
                                      to={`/followups-today?leadholder_id=${item.id}`}
                                    >
                                      {item.due}
                                    </Link>
                                  </td>
                                  <td style={{ background: "silver" }}>
                                    {" "}
                                    <Link
                                      to={`/today-report?leadholder_id=${item.id}&update_by=${item.id}`}
                                    >
                                      {item.done}
                                    </Link>
                                  </td>
                                  <td style={{ background: "white" }}>
                                    {" "}
                                    <Link
                                      to={`/today-report?update_by=${item.id}`}
                                    >
                                      {item.updation}
                                    </Link>
                                  </td>
                                  <td style={{ background: "cyan" }}>
                                    <Link
                                      to={`/leads?lead_type=new&leadholder_id=${
                                        item.id
                                      }&from_date=${formatDate(
                                        dateFilter[0].startDate
                                      )}&to_date=${formatDate(
                                        dateFilter[0].endDate
                                      )}`}
                                    >
                                      {item.new}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      background: "#ff9c00",
                                      color: "white",
                                    }}
                                  >
                                    <Link
                                      to={`/leads?assigned=1&leadholder_id=${
                                        item.id
                                      }&assigned_from=${formatDate(
                                        dateFilter[0].startDate
                                      )}&assigned_to=${formatDate(
                                        dateFilter[0].endDate
                                      )}`}
                                    >
                                      {item.assigned}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      background: "#f0e7d9",
                                      color: "white",
                                    }}
                                  >
                                    <Link
                                      to={`/leads?transfer=1&leadholder_id=${
                                        item.id
                                      }&transfer_from=${formatDate(
                                        dateFilter[0].startDate
                                      )}&transfer_to=${formatDate(
                                        dateFilter[0].endDate
                                      )}`}
                                    >
                                      {item.transfer}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      background: "#f14747",
                                      color: "white",
                                    }}
                                    className="text-light"
                                  >
                                    <Link
                                      to={`/leads?type=dead&leadholder_id=${
                                        item.id
                                      }&from_date=${formatDate(
                                        dateFilter[0].startDate
                                      )}&to_date=${formatDate(
                                        dateFilter[0].endDate
                                      )}`}
                                      className="text-light"
                                    >
                                      {item.dead}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      background: "purple",
                                      color: "white",
                                    }}
                                  >
                                    <Link
                                      to={`/leads?type=dead_request&leadholder_id=${
                                        item.id
                                      }&from_date=${formatDate(
                                        dateFilter[0].startDate
                                      )}&to_date=${formatDate(
                                        dateFilter[0].endDate
                                      )}`}
                                      className="text-light"
                                    >
                                      {item.dead_request}
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      background: "green",
                                      color: "white",
                                    }}
                                  >
                                    &#8377; {item.new_business}{" "}
                                    <Link
                                      to={`/leads?type=matured&business_type=new&leadholder_id=${
                                        item.id
                                      }&from_date=${formatDate(
                                        dateFilter[0].startDate
                                      )}&to_date=${formatDate(
                                        dateFilter[0].endDate
                                      )}`}
                                      className="text-light"
                                    >
                                      ({item.new_business_count})
                                    </Link>
                                  </td>
                                  <td
                                    style={{
                                      background: "gray",
                                      color: "white",
                                    }}
                                  >
                                    &#8377; {item.existing_business}{" "}
                                    <Link
                                      to={`/leads?type=matured&business_type=existing&leadholder_id=${
                                        item.id
                                      }&from_date=${formatDate(
                                        dateFilter[0].startDate
                                      )}&to_date=${formatDate(
                                        dateFilter[0].endDate
                                      )}`}
                                      className="text-light"
                                    >
                                      ({item.existing_business_count})
                                    </Link>
                                  </td>
                                </tr>
                              ))}
                            <tr
                              style={{
                                backgroundColor: "#e9ecef",
                                fontWeight: "bold",
                                borderTop: "3px solid #007bff",
                              }}
                            >
                              <td className="fw-bold">Total</td>
                              <td></td>
                              <td className="fw-bold"></td>
                              <td
                                style={{ background: "silver" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.all_total}
                              </td>
                              <td
                                style={{ background: "white" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.old_total}
                              </td>
                              <td
                                style={{ background: "silver" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.today_total}
                              </td>
                              <td
                                style={{ background: "white" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.due_total}
                              </td>
                              <td
                                style={{ background: "silver" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.done_total}
                              </td>
                              <td
                                style={{ background: "white" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.total_updation}
                              </td>
                              <td
                                style={{ background: "cyan" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.new_total}
                              </td>
                              <td
                                style={{
                                  background: "#ff9c00",
                                  color: "white",
                                }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.assigned_total}
                              </td>
                              <td
                                style={{
                                  background: "#f0e7d9",
                                  color: "white",
                                }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.transfer_total}
                              </td>
                              <td
                                style={{
                                  background: "#f14747",
                                  color: "white",
                                }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.dead_total}
                              </td>
                              <td
                                style={{ background: "purple", color: "white" }}
                                className="fw-bold"
                              >
                                {totalstaffLeads.dead_request_total}
                              </td>
                              <td
                                style={{ background: "green", color: "white" }}
                                className="fw-bold"
                              >
                                &#8377; {totalstaffLeads.new_business_total}(
                                {totalstaffLeads.new_business_count_total})
                              </td>
                              <td
                                style={{ background: "gray", color: "white" }}
                                className="fw-bold"
                              >
                                &#8377;{" "}
                                {totalstaffLeads.existing_business_total}(
                                {totalstaffLeads.existing_business_count_total})
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      {loader}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {getCurrentUser() && getCurrentUser().tag == 1 ? (
                <Row>
                  <Col xl={12}>
                    <Card>
                      <CardBody>
                        <h4 className="card-title mb-4">Lead Tags</h4>
                        <div className="table-responsive">
                          <table className="table table-centered table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>TAG Name</th>
                                <th>Total</th>
                                <th>Matured</th>
                                <th>Matured Amount</th>
                                <th>New</th>
                                <th>Followup</th>
                                <th>Dead</th>
                                <th>Dead Request</th>
                              </tr>
                            </thead>
                            <tbody>
                              {leadTags &&
                                leadTags.map((item, i) => (
                                  <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{item.name}</td>
                                    <td style={{ background: "silver" }}>
                                      {item.total}
                                    </td>
                                    <td
                                      style={{
                                        background: "green",
                                        color: "white",
                                      }}
                                    >
                                      {item.matured}
                                    </td>
                                    <td style={{ background: "white" }}>
                                      &#8377; {item.matured_amount}
                                    </td>
                                    <td style={{ background: "cyan" }}>
                                      {item.new}
                                    </td>
                                    <td
                                      style={{
                                        background: "#ff9c00",
                                        color: "white",
                                      }}
                                    >
                                      {item.followup}
                                    </td>
                                    <td
                                      style={{
                                        background: "#f14747",
                                        color: "white",
                                      }}
                                    >
                                      {item.dead}
                                    </td>
                                    <td
                                      style={{
                                        background: "purple",
                                        color: "white",
                                      }}
                                    >
                                      {item.dead_request}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                          {tagError ? (
                            <span
                              className="text-danger mt-3 d-table m-auto"
                              role="alert"
                            >
                              {tagError}
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                        {loader}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              ) : (
                ""
              )}
            </TabPane>
            <TabPane tabId={4}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      {attendance ? <FullCalendarCompo /> : ""}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={5}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Birthday</h4>
                      <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0">
                          <thead>
                            <tr className="static-header">
                              <th>#</th>
                              <th>Name</th>
                              <th>Contact</th>
                              <th>DOB</th>
                              <th>Anniversary</th>
                            </tr>
                          </thead>
                          <tbody>
                            {birthdayLeads &&
                              birthdayLeads.map((item, i) => (
                                <tr key={i}>
                                  <td>{counter + i}</td>
                                  <td>
                                    <Link
                                      className="text-info"
                                      to={`/leads?id=${item.id}`}
                                    >
                                      {item.name}
                                    </Link>
                                  </td>
                                  <td>{item.number}</td>
                                  <td>{item.dob}</td>
                                  <td>{item.anniversary}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {error ? (
                          <span
                            className="text-danger mt-3 d-table m-auto"
                            role="alert"
                          >
                            {error}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      {loader}
                    </CardBody>
                  </Card>
                  {allPages ? (
                    <Paginations
                      data={allPages}
                      paginate={paginate}
                      perPage={bdySoon ? getBirthdaySoon : getBirthday}
                    />
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={6}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Birthday</h4>
                      <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0">
                          <thead>
                            <tr className="static-header">
                              <th>#</th>
                              <th>Name</th>
                              <th>Contact</th>
                              <th>DOB</th>
                              <th>Anniversary</th>
                            </tr>
                          </thead>
                          <tbody>
                            {usersBirthday &&
                              usersBirthday.map((item, i) => (
                                <tr key={i}>
                                  <td>{counter + i}</td>
                                  <td>{item.name}</td>
                                  <td>{item.phone}</td>
                                  <td>{item.dob}</td>
                                  <td>{item.anniversary}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                        {error ? (
                          <span
                            className="text-danger mt-3 d-table m-auto"
                            role="alert"
                          >
                            {error}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                      {loader}
                    </CardBody>
                  </Card>
                  {allPages ? (
                    <Paginations
                      data={allPages}
                      paginate={paginate}
                      perPage={getUserBirthday}
                    />
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={7}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">
                        <i>Team’s all time data</i>
                      </h4>
                      <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0 team-analysis-table">
                          <thead className="table-light">
                            <tr>
                              <th scope="col" rowSpan="2">
                                #
                              </th>
                              <th scope="col" rowSpan="2">
                                Username
                              </th>
                              <th scope="col" rowSpan="2">
                                Total
                              </th>
                              <th scope="col" rowSpan="2">
                                New
                              </th>
                              <th scope="col" rowSpan="2">
                                Untouched
                              </th>
                              <th scope="col" rowSpan="2">
                                Followup
                                <br />
                                <small>(Click to expand)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Assigned
                                <br />
                                 <small>(Click to expand)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Transferred
                                <br />
                                 <small>(Click to expand)</small>
                              </th> 
                              <th scope="col" rowSpan="2">
                                No Updation
                                <br />
                                <small>(Since 30 days)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Dead
                                <br />
                                <small>(Click to expand)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Dead Request
                                <br />
                                <small>(Click to expand)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Customers
                              </th>
                              <th scope="col" rowSpan="2">
                                No Repeat Order
                              </th>
                              <th scope="col" rowSpan="2">
                                No Order
                                <br />
                                <small>(Since 30 days)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Business
                                <br />
                                <small>(Total)</small>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {teamAnalysisData &&
                              teamAnalysisData.map((user, i) => (
                                <React.Fragment key={i}>
                                  <tr>
                                    <td className="fw-bold">{i + 1}</td>
                                    <td className="text-start">
                                      <Link
                                        className="text-info fw-bold"
                                        to={`/leads?leadholder_id=${user.id}`}
                                      >
                                        {user.name}
                                      </Link>
                                      <br />
                                      {user.role && (
                                        <small className="text-muted">
                                          ({user.role})
                                        </small>
                                      )}
                                    </td>
                                    <td
                                    style={{
                                      background: "#e9ecef",
                                    }}
                                  >
                                    <div className="d-flex align-items-center justify-content-center flex-column">
                                      
                                      <div className="d-flex align-items-center">
                                        
                                        {/* Total Click */}
                                        <Link
                                          to={buildQuery("/leads", {
                                            leadholder_id: user.id,
                                          })}
                                          className="text-dark me-2 fw-bold"
                                        >
                                          {user.total_leads || 0}
                                        </Link>

                                        
                                      </div>

                                      {/* OPTIONAL % (if you want like others) */}
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-dark"
                                      >
                                        (100%)
                                      </small>
                                    </div>
                                  </td>
                                    <td style={{ background: "#d1ecf1" }}>
                                      <div className="text-center">
                                        <Link
                                          to={buildQuery("/leads", {
                                            type: "new",
                                            leadholder_id: user.id,
                                          })}
                                          className="fw-bold d-block"
                                        >
                                          {user.new_leads || 0}
                                        </Link>
                                        <small style={{ fontSize: "9px" }}>
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.new_leads || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td style={{ background: "#fff3cd" }}>
                                      <div className="text-center">
                                        <Link
                                          to={buildQuery("/leads", {
                                            type: "untouched",
                                            assigned: 1,
                                            no_followup: 1,
                                            leadholder_id: user.id,
                                          })}
                                          className="fw-bold d-block"
                                        >
                                          {user.untouched_leads || 0}
                                        </Link>
                                        <small style={{ fontSize: "9px" }}>
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.untouched_leads || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        background: "#ffc107",
                                        color: "white",
                                      }}
                                    >
                                      <div className="d-flex align-items-center justify-content-center flex-column">
                                        <div className="d-flex align-items-center">
                                          <Link
                                            to={buildQuery("/leads", {
                                              type: "followup",
                                              leadholder_id: user.id,
                                            })}
                                            className="text-dark me-2 fw-bold"
                                          >
                                            {user.followup_leads?.total || 0}
                                          </Link>
                                          {user.followup_leads?.statuses
                                            ?.length > 0 && (
                                            <button
                                              onClick={() =>
                                                toggleRowExpansion(
                                                  user.id,
                                                  "followup"
                                                )
                                              }
                                              className="btn btn-sm p-0 expandable-counter"
                                              style={{
                                                background: "transparent",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {expandedRows[
                                                `${user.id}_followup`
                                              ] ? (
                                                <i className="ti-angle-up text-dark"></i>
                                              ) : (
                                                <i className="ti-angle-down text-dark"></i>
                                              )}
                                            </button>
                                          )}
                                        </div>
                                        <small
                                          style={{ fontSize: "9px" }}
                                          className="text-dark"
                                        >
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.followup_leads?.total ||
                                                  0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td style={{ background: "#e9dcdd" }}>
                                      <div className="text-center">
                                        <Link
                                          to={buildQuery("/leads", {
                                            from_date: "",
                                            to_date: "",
                                            assigned2: 1,
                                            assigned_from:
                                              formatDate(dateFilter[0].startDate),
                                              assigned_to:
                                              formatDate(dateFilter[0].endDate),
                                            leadholder_id: user.id,
                                          })}
                                          className="fw-bold d-block"
                                        >
                                          {user.assigned || 0}
                                        </Link>
                                        <small style={{ fontSize: "9px" }}>
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.assigned || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td style={{ background: "#e0dfd1" }}>
                                      <div className="text-center">
                                        <Link
                                          to={buildQuery("/leads", {
                                            no_updation: 1,
                                            transfer_from:
                                            formatDate(dateFilter[0].startDate),
                                            transfer_to:
                                            formatDate(dateFilter[0].endDate),
                                            leadholder_id: user.id,
                                          })}
                                          className="fw-bold d-block"
                                        >
                                          {user.transfer || 0}
                                        </Link>
                                        <small style={{ fontSize: "9px" }}>
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.transfer || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td style={{ background: "#f8d7da" }}>
                                      <div className="text-center">
                                        <Link
                                          to={buildQuery("/leads", {
                                            no_updation: 1,
                                            no_updation_from_date:
                                              formatDate(fromDate),
                                            leadholder_id: user.id,
                                          })}
                                          className="fw-bold d-block"
                                        >
                                          {user.no_updation_leads || 0}
                                        </Link>
                                        <small style={{ fontSize: "9px" }}>
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.no_updation_leads || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        background: "#dc3545",
                                        color: "white",
                                      }}
                                    >
                                      <div className="d-flex align-items-center justify-content-center flex-column">
                                        <div className="d-flex align-items-center">
                                          <Link
                                            to={buildQuery("/leads", {
                                              type: "dead",
                                              leadholder_id: user.id,
                                            })}
                                            className="text-light me-2 fw-bold"
                                          >
                                            {user.dead_leads?.total || 0}
                                          </Link>
                                          {user.dead_leads?.reasons?.length >
                                            0 && (
                                            <button
                                              onClick={() =>
                                                toggleRowExpansion(
                                                  user.id,
                                                  "dead"
                                                )
                                              }
                                              className="btn btn-sm p-0 expandable-counter"
                                              style={{
                                                background: "transparent",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {expandedRows[
                                                `${user.id}_dead`
                                              ] ? (
                                                <i className="ti-angle-up text-white"></i>
                                              ) : (
                                                <i className="ti-angle-down text-white"></i>
                                              )}
                                            </button>
                                          )}
                                        </div>
                                        <small
                                          style={{ fontSize: "9px" }}
                                          className="text-light"
                                        >
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.dead_leads?.total || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        background: "#6f42c1",
                                        color: "white",
                                      }}
                                    >
                                      <div className="d-flex align-items-center justify-content-center flex-column">
                                        <div className="d-flex align-items-center">
                                          <Link
                                            to={buildQuery("/leads", {
                                              type: "dead_request",
                                              leadholder_id: user.id,
                                            })}
                                            className="text-light me-2 fw-bold"
                                          >
                                            {user.dead_request_leads?.total ||
                                              0}
                                          </Link>
                                          {user.dead_request_leads?.reasons
                                            ?.length > 0 && (
                                            <button
                                              onClick={() =>
                                                toggleRowExpansion(
                                                  user.id,
                                                  "dead_request"
                                                )
                                              }
                                              className="btn btn-sm p-0 expandable-counter"
                                              style={{
                                                background: "transparent",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {expandedRows[
                                                `${user.id}_dead_request`
                                              ] ? (
                                                <i className="ti-angle-up text-white"></i>
                                              ) : (
                                                <i className="ti-angle-down text-white"></i>
                                              )}
                                            </button>
                                          )}
                                        </div>
                                        <small
                                          style={{ fontSize: "9px" }}
                                          className="text-light"
                                        >
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.dead_request_leads
                                                  ?.total || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        background: "#28a745",
                                        color: "white",
                                      }}
                                    >
                                      <div className="text-center">
                                        <Link
                                          to={buildQuery("/leads", {
                                            type: "matured",
                                            leadholder_id: user.id,
                                          })}
                                          className="text-light fw-bold d-block"
                                        >
                                          {user.customers || 0}
                                        </Link>
                                        <small
                                          style={{ fontSize: "9px" }}
                                          className="text-light"
                                        >
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.customers || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        background: "#17a2b8",
                                        color: "white",
                                      }}
                                    >
                                      <Link
                                        to={`/customers?single_order_only=1&leadholder_id=${user.id}`}
                                        className="text-light"
                                      >
                                        {user.no_repeat_order || 0}
                                      </Link>
                                    </td>
                                    <td
                                      style={{
                                        background: "#fd7e14",
                                        color: "white",
                                      }}
                                    >
                                      <Link
                                        to={`/customers?no_order_since=${formatDate(
                                          fromDate
                                        )}&leadholder_id=${user.id}`}
                                        className="text-light"
                                      >
                                        {user.no_order_since || 0}
                                      </Link>
                                    </td>
                                    <td
                                      style={{
                                        background: "#20c997",
                                        color: "white",
                                      }}
                                    >
                                      <div className="text-center">
                                        <div className="fw-bold">
                                          &#8377;{" "}
                                          {(
                                            (user.new_business || 0) +
                                            (user.repeat_business || 0)
                                          ).toLocaleString()}
                                        </div>
                                        <small style={{ fontSize: "9px" }}>
                                          New: &#8377;{" "}
                                          {(
                                            user.new_business || 0
                                          ).toLocaleString()}
                                          <br />
                                          Repeat: &#8377;{" "}
                                          {(
                                            user.repeat_business || 0
                                          ).toLocaleString()}
                                        </small>
                                      </div>
                                    </td>
                                  </tr>
                                  {/* Expanded rows for Dead reasons */}
                                  {expandedRows[`${user.id}_dead`] &&
                                    user.dead_leads?.reasons?.length > 0 && (
                                      <tr>
                                        <td
                                          colSpan="13"
                                          className="reason-badges"
                                          style={{
                                            background: "#f8f9fa",
                                            padding: "15px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-12">
                                              <strong className="text-danger mb-3 d-block fs-6">
                                                Dead Reasons:
                                              </strong>
                                              <div className="d-flex flex-wrap justify-content-center">
                                                {user.dead_leads.reasons.map(
                                                  (reason, idx) => (
                                                    <Link
                                                      key={idx}
                                                      to={buildQuery("/leads", {
                                                        type: "dead",
                                                        leadholder_id: user.id,
                                                        dead_reason_id:
                                                          reason.id,
                                                      })}
                                                      className="badge bg-danger mx-1 mb-2"
                                                      title={`${
                                                        reason.reason
                                                      } - ${
                                                        reason.count
                                                      } leads (${
                                                        user.dead_leads.total >
                                                        0
                                                          ? (
                                                              (reason.count /
                                                                user.dead_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0
                                                      }%)`}
                                                      style={{
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      {reason.count}{" "}
                                                      {reason.reason}
                                                      <br />
                                                      <small
                                                        style={{
                                                          fontSize: "9px",
                                                        }}
                                                      >
                                                        (
                                                        {user.dead_leads.total >
                                                        0
                                                          ? (
                                                              (reason.count /
                                                                user.dead_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0}
                                                        %)
                                                      </small>
                                                    </Link>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  {/* Expanded rows for Dead Request reasons */}
                                  {expandedRows[`${user.id}_dead_request`] &&
                                    user.dead_request_leads?.reasons?.length >
                                      0 && (
                                      <tr>
                                        <td
                                          colSpan="13"
                                          className="reason-badges"
                                          style={{
                                            background: "#f8f9fa",
                                            padding: "15px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-12">
                                              <strong className="text-primary mb-3 d-block fs-6">
                                                Dead Request Reasons:
                                              </strong>
                                              <div className="d-flex flex-wrap justify-content-center">
                                                {user.dead_request_leads.reasons.map(
                                                  (reason, idx) => (
                                                    <Link
                                                      key={idx}
                                                      to={buildQuery("/leads", {
                                                        type: "dead_request",
                                                        leadholder_id: user.id,
                                                        dead_reason_id:
                                                          reason.id,
                                                      })}
                                                      className="badge bg-primary mx-1 mb-2"
                                                      title={`${
                                                        reason.reason
                                                      } - ${
                                                        reason.count
                                                      } leads (${
                                                        user.dead_request_leads
                                                          .total > 0
                                                          ? (
                                                              (reason.count /
                                                                user
                                                                  .dead_request_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0
                                                      }%)`}
                                                      style={{
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      {reason.count}{" "}
                                                      {reason.reason}
                                                      <br />
                                                      <small
                                                        style={{
                                                          fontSize: "9px",
                                                        }}
                                                      >
                                                        (
                                                        {user.dead_request_leads
                                                          .total > 0
                                                          ? (
                                                              (reason.count /
                                                                user
                                                                  .dead_request_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0}
                                                        %)
                                                      </small>
                                                    </Link>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  {/* Expanded rows for Followup statuses */}
                                  {expandedRows[`${user.id}_followup`] &&
                                    user.followup_leads?.statuses?.length >
                                      0 && (
                                      <tr>
                                        <td
                                          colSpan="13"
                                          className="reason-badges"
                                          style={{
                                            background: "#f8f9fa",
                                            padding: "15px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-12">
                                              <strong className="text-warning mb-3 d-block fs-6">
                                                Followup Statuses:
                                              </strong>
                                              <div className="d-flex flex-wrap justify-content-center">
                                                {user.followup_leads.statuses.map(
                                                  (status, idx) => (
                                                    <Link
                                                      key={idx}
                                                      to={buildQuery("/leads", {
                                                        followup_status_id:
                                                          status.id,
                                                        leadholder_id: user.id,
                                                      })}
                                                      className="badge bg-warning mx-1 mb-2 text-dark"
                                                      title={`${
                                                        status.status
                                                      } - ${
                                                        status.count
                                                      } leads (${
                                                        user.followup_leads
                                                          .total > 0
                                                          ? (
                                                              (status.count /
                                                                user
                                                                  .followup_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0
                                                      }%)`}
                                                      style={{
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      {status.count}{" "}
                                                      {status.status}
                                                      <br />
                                                      <small
                                                        style={{
                                                          fontSize: "9px",
                                                        }}
                                                      >
                                                        (
                                                        {user.followup_leads
                                                          .total > 0
                                                          ? (
                                                              (status.count /
                                                                user
                                                                  .followup_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0}
                                                        %)
                                                      </small>
                                                    </Link>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                    

                                </React.Fragment>
                              ))}
                            {/* Totals Row */}
                            {teamAnalysisData &&
                              teamAnalysisData.length > 0 && (
                                <tr
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    fontWeight: "bold",
                                    borderTop: "3px solid #007bff",
                                  }}
                                >
                                  <td className="fw-bold">#</td>
                                  <td className="text-start fw-bold">TOTAL</td>
                                  <td
                                    style={{ background: "#e9ecef" }}
                                    className="fw-bold"
                                  >
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.total_leads || 0),
                                      0
                                    )}
                                  </td>
                                  <td
                                    style={{ background: "#d1ecf1" }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.new_leads || 0),
                                          0
                                        )}
                                      </span>
                                      <small style={{ fontSize: "9px" }}>
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalNew =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.new_leads || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalNew / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{ background: "#fff3cd" }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.untouched_leads || 0),
                                          0
                                        )}
                                      </span>
                                      <small style={{ fontSize: "9px" }}>
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalUntouched =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.untouched_leads || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalUntouched / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      background: "#ffc107",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="text-dark d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum +
                                            (user.followup_leads?.total || 0),
                                          0
                                        )}
                                      </span>
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-dark"
                                      >
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalFollowup =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.followup_leads?.total ||
                                                  0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalFollowup / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{ background: "#f8d7da" }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.transfer || 0),
                                          0
                                        )}
                                      </span>
                                      <small style={{ fontSize: "9px" }}>
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalTransfer =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.transfer || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalTransfer / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{ background: "#f8d7da" }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.assigned || 0),
                                          0
                                        )}
                                      </span>
                                      <small style={{ fontSize: "9px" }}>
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalAssigned =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.assigned || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalAssigned / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{ background: "#f8d7da" }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.no_updation_leads || 0),
                                          0
                                        )}
                                      </span>
                                      <small style={{ fontSize: "9px" }}>
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalNoUpdation =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.no_updation_leads || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalNoUpdation / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  
                                  <td
                                    style={{
                                      background: "#dc3545",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="text-light d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.dead_leads?.total || 0),
                                          0
                                        )}
                                      </span>
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-light"
                                      >
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalDead =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.dead_leads?.total || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalDead / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      background: "#6f42c1",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="text-light d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum +
                                            (user.dead_request_leads?.total ||
                                              0),
                                          0
                                        )}
                                      </span>
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-light"
                                      >
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalDeadRequest =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.dead_request_leads
                                                  ?.total || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalDeadRequest /
                                                  totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      background: "#28a745",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="text-light d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.customers || 0),
                                          0
                                        )}
                                      </span>
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-light"
                                      >
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalCustomers =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.customers || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalCustomers / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      background: "#17a2b8",
                                      color: "white",
                                    }}
                                    className="fw-bold text-light"
                                  >
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.no_repeat_order || 0),
                                      0
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      background: "#fd7e14",
                                      color: "white",
                                    }}
                                    className="fw-bold text-light"
                                  >
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.no_order_since || 0),
                                      0
                                    )}
                                  </td>
                                  <td
                                    style={{
                                      background: "#20c997",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <div>
                                        &#8377;{" "}
                                        {teamAnalysisData
                                          .reduce(
                                            (sum, user) =>
                                              sum +
                                              (user.new_business || 0) +
                                              (user.repeat_business || 0),
                                            0
                                          )
                                          .toLocaleString()}
                                      </div>
                                      <small style={{ fontSize: "9px" }}>
                                        New: &#8377;{" "}
                                        {teamAnalysisData
                                          .reduce(
                                            (sum, user) =>
                                              sum + (user.new_business || 0),
                                            0
                                          )
                                          .toLocaleString()}
                                        <br />
                                        Repeat: &#8377;{" "}
                                        {teamAnalysisData
                                          .reduce(
                                            (sum, user) =>
                                              sum + (user.repeat_business || 0),
                                            0
                                          )
                                          .toLocaleString()}
                                      </small>
                                    </div>
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                        {error ? (
                          <div className="text-center mt-3">
                            <span className="text-danger" role="alert">
                              {error}
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                        {teamAnalysisData.length === 0 && !loader && (
                          <div className="text-center mt-3">
                            <span className="text-muted">
                              No team data available
                            </span>
                          </div>
                        )}
                      </div>
                      {loader}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={9}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Today's Reports</h4>
                      <div className="lead_table table table-sm table-bordered table-responsive">
                        <table
                          className="table table-centered table-nowrap mb-0 dash-table"
                          style={{ width: "100%" }}
                        >
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Customer</th>
                              <th scope="col">Message Updated</th>
                              <th scope="col">Previous Message</th>
                              <th scope="col">Updated By</th>
                              <th scope="col">Leadholder</th>
                              <th scope="col">Label</th>
                              <th scope="col">Lead Source</th>
                              <th scope="col">Action</th>
                              <th scope="col">Lead Status</th>
                              <th scope="col">Date & Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {todayReport &&
                              todayReport.map((item, obj) => (
                                <TodayList
                                  check={false}
                                  key={obj}
                                  data={item}
                                  i={obj}
                                  counter={counter2}
                                  getTodayReport={getTodayReport}
                                />
                              ))}
                          </tbody>
                        </table>
                      </div>
                      {loader}
                      <div className="d-flex justify-content-center">
                        <Link
                          to={`today-report`}
                          className="btn btn-primary text-center"
                        >
                          More Reports
                        </Link>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            {/* For MIS Table View*/}
            <TabPane tabId={8}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">
                        This month data <i>(data available, max last 2 months)</i>
                      </h4>
                      <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0 team-analysis-table">
                          <thead className="table-light">
                            <tr>
                              <th scope="col" rowSpan="2">
                                #
                              </th>
                              <th scope="col" rowSpan="2">
                                Username
                              </th>
                              <th scope="col" rowSpan="2">
                                Leads
                              </th>
                              <th scope="col" rowSpan="2">
                                Updation
                              </th>
                              <th scope="col" rowSpan="2">
                                Followup
                                <br />
                                <small>(Click to expand)</small>
                              </th>
                              
                              
                              <th scope="col" rowSpan="2">
                                Dead
                                <br />
                                <small>(Click to expand)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Dead Request
                                <br />
                                <small>(Click to expand)</small>
                              </th>
                              
                              <th scope="col" rowSpan="2">
                                New Order
                              </th>
                              <th scope="col" rowSpan="2">
                                Amount Received/Pending
                              </th>
                              <th scope="col" rowSpan="2">
                                Repeat Order
                              </th>
                              <th scope="col" rowSpan="2">
                                Amount Received/Pending
                              </th>
                              <th scope="col" rowSpan="2">
                                Total Business
                                <br />
                                <small>(Total Orders)</small>
                              </th>
                              <th scope="col" rowSpan="2">
                                Amount Received/Pending
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {teamAnalysisData &&
                              teamAnalysisData.map((user, i) => (
                                <React.Fragment key={i}>
                                  <tr>
                                    <td className="fw-bold">{i + 1}</td>
                                    <td className="text-start">
                                      <Link
                                        className="text-info fw-bold"
                                        to={`/leads?leadholder_id=${user.id}`}
                                      >
                                        {user.name}
                                      </Link>
                                      <br />
                                      {user.role && (
                                        <small className="text-muted">
                                          ({user.role})
                                        </small>
                                      )}
                                    </td>
                                    <td
                                    style={{
                                      background: "#e9ecef",
                                    }}
                                  >
                                    <div className="d-flex align-items-center justify-content-center flex-column">
                                      
                                      <div className="d-flex align-items-center">
                                        <span className="text-dark me-2 fw-bold">
                                          {user.total_leads || 0}
                                        </span>
                                        {(user.total_leads || 0) > 0 && (
                                          <button
                                            onClick={() => {
                                              toggleRowExpansion(user.id, "total")
                                            }}
                                            className="btn btn-sm p-0 expandable-counter"
                                            style={{
                                              background: "transparent",
                                              fontSize: "10px",
                                            }}
                                          >
                                            {expandedRows[`${user.id}_total`] ? (
                                              <i className="ti-angle-up text-dark"></i>
                                            ) : (
                                              <i className="ti-angle-down text-dark"></i>
                                            )}
                                          </button>
                                        )}
                                      </div>

                                      {/* OPTIONAL % (if you want like others) */}
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-dark"
                                      >
                                        (100%)
                                      </small>
                                    </div>
                                  </td>
                                    
                                    
                                    

                                    <td style={{ background: "#d9b5de" }}>
                                      <div className="text-center">
                                       {/* <Link
                                          to={buildQuery("/leads", {
                                            type: "updation",
                                            assigned: 1,
                                            no_followup: 1,
                                            leadholder_id: user.id,
                                          })}
                                          className="fw-bold d-block"
                                        >
                                          {user.total_lead_updates || 0}
                                        </Link> */}
                                         <b>{user.total_lead_updates || 0}</b>
                                      </div>
                                    </td>

                                    <td
                                      style={{
                                        background: "#ffc107",
                                        color: "white",
                                      }}
                                    >
                                      <div className="d-flex align-items-center justify-content-center flex-column">
                                        <div className="d-flex align-items-center">
                                          <Link
                                            to={buildQuery("/leads", {
                                              type: "followup",
                                              leadholder_id: user.id,
                                            })}
                                            className="text-dark me-2 fw-bold"
                                          >
                                            {user.followup_leads?.total || 0}
                                          </Link>
                                          {user.followup_leads?.statuses
                                            ?.length > 0 && (
                                            <button
                                              onClick={() =>
                                                toggleRowExpansion(
                                                  user.id,
                                                  "followup"
                                                )
                                              }
                                              className="btn btn-sm p-0 expandable-counter"
                                              style={{
                                                background: "transparent",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {expandedRows[
                                                `${user.id}_followup`
                                              ] ? (
                                                <i className="ti-angle-up text-dark"></i>
                                              ) : (
                                                <i className="ti-angle-down text-dark"></i>
                                              )}
                                            </button>
                                          )}
                                        </div>
                                        <small
                                          style={{ fontSize: "9px" }}
                                          className="text-dark"
                                        >
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.followup_leads?.total ||
                                                  0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    
                                    
                                    <td
                                      style={{
                                        background: "#dc3545",
                                        color: "white",
                                      }}
                                    >
                                      <div className="d-flex align-items-center justify-content-center flex-column">
                                        <div className="d-flex align-items-center">
                                          <Link
                                            to={buildQuery("/leads", {
                                              type: "dead",
                                              leadholder_id: user.id,
                                            })}
                                            className="text-light me-2 fw-bold"
                                          >
                                            {user.dead_leads?.total || 0}
                                          </Link>
                                          {user.dead_leads?.reasons?.length >
                                            0 && (
                                            <button
                                              onClick={() =>
                                                toggleRowExpansion(
                                                  user.id,
                                                  "dead"
                                                )
                                              }
                                              className="btn btn-sm p-0 expandable-counter"
                                              style={{
                                                background: "transparent",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {expandedRows[
                                                `${user.id}_dead`
                                              ] ? (
                                                <i className="ti-angle-up text-white"></i>
                                              ) : (
                                                <i className="ti-angle-down text-white"></i>
                                              )}
                                            </button>
                                          )}
                                        </div>
                                        <small
                                          style={{ fontSize: "9px" }}
                                          className="text-light"
                                        >
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.dead_leads?.total || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        background: "#6f42c1",
                                        color: "white",
                                      }}
                                    >
                                      <div className="d-flex align-items-center justify-content-center flex-column">
                                        <div className="d-flex align-items-center">
                                          <Link
                                            to={buildQuery("/leads", {
                                              type: "dead_request",
                                              leadholder_id: user.id,
                                            })}
                                            className="text-light me-2 fw-bold"
                                          >
                                            {user.dead_request_leads?.total ||
                                              0}
                                          </Link>
                                          {user.dead_request_leads?.reasons
                                            ?.length > 0 && (
                                            <button
                                              onClick={() =>
                                                toggleRowExpansion(
                                                  user.id,
                                                  "dead_request"
                                                )
                                              }
                                              className="btn btn-sm p-0 expandable-counter"
                                              style={{
                                                background: "transparent",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {expandedRows[
                                                `${user.id}_dead_request`
                                              ] ? (
                                                <i className="ti-angle-up text-white"></i>
                                              ) : (
                                                <i className="ti-angle-down text-white"></i>
                                              )}
                                            </button>
                                          )}
                                        </div>
                                        <small
                                          style={{ fontSize: "9px" }}
                                          className="text-light"
                                        >
                                          (
                                          {user.total_leads > 0
                                            ? (
                                                ((user.dead_request_leads
                                                  ?.total || 0) /
                                                  user.total_leads) *
                                                100
                                              ).toFixed(1)
                                            : 0}
                                          %)
                                        </small>
                                      </div>
                                    </td>
                                    
                                    <td
                                      style={{
                                        background: "#4ec193f9",
                                        color: "white",
                                      }}
                                    >
                                     {/*} <Link
                                        to="#"
                                        className="text-light"
                                      >
                                         &#8377;{user.new_business || 0} | ({user.new_business_count || 0})
                                      </Link> */}
                                      &#8377;{user.new_business || 0} | ({user.new_business_count || 0})
                                    </td>
                                    
                                    <td
                                      style={{
                                        background: "#4ec193f9",
                                        color: "white",
                                      }}
                                    >
                                      {/*<Link
                                        to={`/customers?no_order_since=${formatDate(
                                          fromDate
                                        )}&leadholder_id=${user.id}`}
                                        className="text-light"
                                      >
                                         &#8377;{user.new_received || 0} | ({user.new_outstanding || 0})
                                      </Link> */}
                                      &#8377;{user.new_received || 0} | ({user.new_outstanding || 0})
                                    </td>
                                    <td
                                      style={{
                                        background: "#82c665",
                                        color: "white",
                                      }}
                                    >
                                     {/* <Link
                                        to={`/customers?no_order_since=${formatDate(
                                          fromDate
                                        )}&leadholder_id=${user.id}`}
                                        className="text-light"
                                      >
                                         &#8377;{user.repeat_business || 0} | ({user.repeat_business_count || 0})
                                      </Link>  */}
                                      &#8377;{user.repeat_business || 0} | ({user.repeat_business_count || 0})
                                    </td>
                                    <td
                                      style={{
                                        background: "#82c665",
                                        color: "white",
                                      }}
                                    >
                                     {/* <Link
                                        to={`/customers?no_order_since=${formatDate(
                                          fromDate
                                        )}&leadholder_id=${user.id}`}
                                        className="text-light"
                                      >
                                         &#8377;{user.repeat_received || 0} | ({user.repeat_outstanding || 0})
                                      </Link> */}
                                      &#8377;{user.repeat_received || 0} | ({user.repeat_outstanding || 0})
                                    </td>
                                    <td
                                      style={{
                                        background: "#b7b7b7d3",
                                        color: "white",
                                      }}
                                    >
                                      <div className="text-center">
                                        <div className="fw-bold">
                                          &#8377;{" "}
                                          {(
                                            (user.new_business || 0) +
                                            (user.repeat_business || 0)
                                          ).toLocaleString()} | ({user.total_order_count || 0})
                                        </div>
                                        {/*<small style={{ fontSize: "9px" }}>
                                          New: &#8377;{" "}
                                          {(
                                            user.new_business || 0
                                          ).toLocaleString()}
                                          <br />
                                          Repeat: &#8377;{" "}
                                          {(
                                            user.repeat_business || 0
                                          ).toLocaleString()}
                                        </small> */}
                                      </div>
                                    </td>
                                    <td
                                      style={{
                                        background: "#b7b7b7d3",
                                        color: "white",
                                      }}
                                    >
                                      <div className="text-center">
                                        <div className="fw-bold">
                                          &#8377;{" "}
                                          {(user.total_received || 0 ).toLocaleString()} | ({user.total_outstanding || 0})
                                        </div>
                                        {/*<small style={{ fontSize: "9px" }}>
                                          New: &#8377;{" "}
                                          {(
                                            user.new_business || 0
                                          ).toLocaleString()}
                                          <br />
                                          Repeat: &#8377;{" "}
                                          {(
                                            user.repeat_business || 0
                                          ).toLocaleString()}
                                        </small> */}
                                      </div>
                                    </td>
                                  </tr>
                                  {/* Expanded rows for Dead reasons */}
                                  {expandedRows[`${user.id}_dead`] &&
                                    user.dead_leads?.reasons?.length > 0 && (
                                      <tr>
                                        <td
                                          colSpan="13"
                                          className="reason-badges"
                                          style={{
                                            background: "#f8f9fa",
                                            padding: "15px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-12">
                                              <strong className="text-danger mb-3 d-block fs-6">
                                                Dead Reasons:
                                              </strong>
                                              <div className="d-flex flex-wrap justify-content-center">
                                                {user.dead_leads.reasons.map(
                                                  (reason, idx) => (
                                                    <Link
                                                      key={idx}
                                                      to={buildQuery("/leads", {
                                                        type: "dead",
                                                        leadholder_id: user.id,
                                                        dead_reason_id:
                                                          reason.id,
                                                      })}
                                                      className="badge bg-danger mx-1 mb-2"
                                                      title={`${
                                                        reason.reason
                                                      } - ${
                                                        reason.count
                                                      } leads (${
                                                        user.dead_leads.total >
                                                        0
                                                          ? (
                                                              (reason.count /
                                                                user.dead_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0
                                                      }%)`}
                                                      style={{
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      {reason.count}{" "}
                                                      {reason.reason}
                                                      <br />
                                                      <small
                                                        style={{
                                                          fontSize: "9px",
                                                        }}
                                                      >
                                                        (
                                                        {user.dead_leads.total >
                                                        0
                                                          ? (
                                                              (reason.count /
                                                                user.dead_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0}
                                                        %)
                                                      </small>
                                                    </Link>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  {/* Expanded rows for Dead Request reasons */}
                                  {expandedRows[`${user.id}_dead_request`] &&
                                    user.dead_request_leads?.reasons?.length >
                                      0 && (
                                      <tr>
                                        <td
                                          colSpan="13"
                                          className="reason-badges"
                                          style={{
                                            background: "#f8f9fa",
                                            padding: "15px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-12">
                                              <strong className="text-primary mb-3 d-block fs-6">
                                                Dead Request Reasons:
                                              </strong>
                                              <div className="d-flex flex-wrap justify-content-center">
                                                {user.dead_request_leads.reasons.map(
                                                  (reason, idx) => (
                                                    <Link
                                                      key={idx}
                                                      to={buildQuery("/leads", {
                                                        type: "dead_request",
                                                        leadholder_id: user.id,
                                                        dead_reason_id:
                                                          reason.id,
                                                      })}
                                                      className="badge bg-primary mx-1 mb-2"
                                                      title={`${
                                                        reason.reason
                                                      } - ${
                                                        reason.count
                                                      } leads (${
                                                        user.dead_request_leads
                                                          .total > 0
                                                          ? (
                                                              (reason.count /
                                                                user
                                                                  .dead_request_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0
                                                      }%)`}
                                                      style={{
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      {reason.count}{" "}
                                                      {reason.reason}
                                                      <br />
                                                      <small
                                                        style={{
                                                          fontSize: "9px",
                                                        }}
                                                      >
                                                        (
                                                        {user.dead_request_leads
                                                          .total > 0
                                                          ? (
                                                              (reason.count /
                                                                user
                                                                  .dead_request_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0}
                                                        %)
                                                      </small>
                                                    </Link>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                  {/* Expanded rows for Followup statuses */}
                                  {expandedRows[`${user.id}_followup`] &&
                                    user.followup_leads?.statuses?.length >
                                      0 && (
                                      <tr>
                                        <td
                                          colSpan="13"
                                          className="reason-badges"
                                          style={{
                                            background: "#f8f9fa",
                                            padding: "15px",
                                          }}
                                        >
                                          <div className="row">
                                            <div className="col-12">
                                              <strong className="text-warning mb-3 d-block fs-6">
                                                Followup Statuses:
                                              </strong>
                                              <div className="d-flex flex-wrap justify-content-center">
                                                {user.followup_leads.statuses.map(
                                                  (status, idx) => (
                                                    <Link
                                                      key={idx}
                                                      to={buildQuery("/leads", {
                                                        followup_status_id:
                                                          status.id,
                                                        leadholder_id: user.id,
                                                      })}
                                                      className="badge bg-warning mx-1 mb-2 text-dark"
                                                      title={`${
                                                        status.status
                                                      } - ${
                                                        status.count
                                                      } leads (${
                                                        user.followup_leads
                                                          .total > 0
                                                          ? (
                                                              (status.count /
                                                                user
                                                                  .followup_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0
                                                      }%)`}
                                                      style={{
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      {status.count}{" "}
                                                      {status.status}
                                                      <br />
                                                      <small
                                                        style={{
                                                          fontSize: "9px",
                                                        }}
                                                      >
                                                        (
                                                        {user.followup_leads
                                                          .total > 0
                                                          ? (
                                                              (status.count /
                                                                user
                                                                  .followup_leads
                                                                  .total) *
                                                              100
                                                            ).toFixed(1)
                                                          : 0}
                                                        %)
                                                      </small>
                                                    </Link>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    )}
                                    {expandedRows[`${user.id}_total`] &&
                                      (user.total_leads || 0) > 0 && (
                                        <tr>
                                          <td
                                            colSpan="15"
                                            className="reason-badges"
                                            style={{
                                              background: "#f8f9fa",
                                              padding: "15px",
                                            }}
                                          >
                                            <div className="row">
                                              <div className="col-12">
                                                <strong className="text-dark mb-3 d-block fs-6">
                                                  Total Lead Breakdown:
                                                </strong>
                                                <div className="d-flex flex-wrap justify-content-center">
                                                  {misLeadBreakdownItems.map(
                                                    item => {
                                                      const count =
                                                        getMisLeadBreakdown(user)[
                                                          item.key
                                                        ] || 0
                                                      if (count <= 0) {
                                                        return null
                                                      }

                                                      return (
                                                        <span
                                                          key={item.key}
                                                          className={`badge ${item.className} mx-1 mb-2 text-dark`}
                                                          style={{
                                                            fontSize: "11px",
                                                          }}
                                                        >
                                                          {count} {item.label}
                                                          <br />
                                                          <small
                                                            style={{
                                                              fontSize: "9px",
                                                            }}
                                                          >
                                                            (
                                                            {user.total_leads > 0
                                                              ? (
                                                                  (count /
                                                                    user.total_leads) *
                                                                  100
                                                                ).toFixed(1)
                                                              : 0}
                                                            %)
                                                          </small>
                                                        </span>
                                                      )
                                                    }
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                </React.Fragment>
                              ))}
                            {/* Totals Row */}
                            {teamAnalysisData &&
                              teamAnalysisData.length > 0 && (
                                <tr
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    fontWeight: "bold",
                                    borderTop: "3px solid #007bff",
                                  }}
                                >
                                  <td className="fw-bold">#</td>
                                  <td className="text-start fw-bold">TOTAL</td>
                                  <td
                                    style={{ background: "#e9ecef" }}
                                    className="fw-bold"
                                  >
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.total_leads || 0),
                                      0
                                    )}
                                  </td>
                                  
                                  <td
                                    style={{ background: "#d9b5de" }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.total_lead_updates || 0),
                                          0
                                        )}
                                      </span>
                                      
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      background: "#ffc107",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="text-dark d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum +
                                            (user.followup_leads?.total || 0),
                                          0
                                        )}
                                      </span>
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-dark"
                                      >
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalFollowup =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.followup_leads?.total ||
                                                  0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalFollowup / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  
                                  
                                  
                                  
                                  <td
                                    style={{
                                      background: "#dc3545",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="text-light d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum + (user.dead_leads?.total || 0),
                                          0
                                        )}
                                      </span>
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-light"
                                      >
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalDead =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.dead_leads?.total || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalDead / totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      background: "#6f42c1",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <span className="text-light d-block">
                                        {teamAnalysisData.reduce(
                                          (sum, user) =>
                                            sum +
                                            (user.dead_request_leads?.total ||
                                              0),
                                          0
                                        )}
                                      </span>
                                      <small
                                        style={{ fontSize: "9px" }}
                                        className="text-light"
                                      >
                                        (
                                        {(() => {
                                          const totalLeads =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum + (user.total_leads || 0),
                                              0
                                            )
                                          const totalDeadRequest =
                                            teamAnalysisData.reduce(
                                              (sum, user) =>
                                                sum +
                                                (user.dead_request_leads
                                                  ?.total || 0),
                                              0
                                            )
                                          return totalLeads > 0
                                            ? (
                                                (totalDeadRequest /
                                                  totalLeads) *
                                                100
                                              ).toFixed(1)
                                            : 0
                                        })()}
                                        %)
                                      </small>
                                    </div>
                                  </td>
                                  
                                  <td
                                    style={{
                                      background: "#4ec193f9",
                                      color: "white",
                                    }}
                                    className="fw-bold text-light"
                                  >
                                    &#8377;{" "}
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.new_business || 0),
                                      0
                                    )} | ({teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.new_business_count || 0),
                                      0
                                    )})
                                  </td>
                                  
                                  <td
                                    style={{
                                      background: "#4ec193f9",
                                      color: "white",
                                    }}
                                    className="fw-bold text-light"
                                  >
                                    &#8377;{" "}
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.new_received || 0),
                                      0
                                    )} | ({teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.new_outstanding || 0),
                                      0
                                    )})
                                  </td>
                                  <td
                                    style={{
                                      background: "#82c665",
                                      color: "white",
                                    }}
                                    className="fw-bold text-light"
                                  >
                                    &#8377;{" "}
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.repeat_business || 0),
                                      0
                                    )} | ({teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.repeat_business_count || 0),
                                      0
                                    )})
                                  </td>
                                  <td
                                    style={{
                                      background: "#82c665",
                                      color: "white",
                                    }}
                                    className="fw-bold text-light"
                                  >
                                    &#8377;{" "}
                                    {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.repeat_received || 0),
                                      0
                                    )} | ({teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.repeat_outstanding || 0),
                                      0
                                    )})
                                  </td>
                                  <td
                                    style={{
                                      background: "#b7b7b7d3",
                                      color: "white",
                                    }}
                                    className="fw-bold text-light"
                                  >
                                    &#8377;{" "}
                                        {teamAnalysisData
                                          .reduce(
                                            (sum, user) =>
                                              sum +
                                              (user.new_business || 0) +
                                              (user.repeat_business || 0),
                                            0
                                          )
                                          .toLocaleString()} | ({teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.total_order_count || 0),
                                      0
                                    )})
                                  </td>
                                  <td
                                    style={{
                                      background: "#b7b7b7d3",
                                      color: "white",
                                    }}
                                    className="fw-bold"
                                  >
                                    <div className="text-center">
                                      <div>
                                       &#8377;{" "}
                                        {teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.total_received || 0),
                                      0
                                    )} | ({teamAnalysisData.reduce(
                                      (sum, user) =>
                                        sum + (user.total_outstanding || 0),
                                      0
                                    )})
                                      </div>
                                      
                                    </div>
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                        {error ? (
                          <div className="text-center mt-3">
                            <span className="text-danger" role="alert">
                              {error}
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                        {teamAnalysisData.length === 0 && !loader && (
                          <div className="text-center mt-3">
                            <span className="text-muted">
                              No team data available
                            </span>
                          </div>
                        )}
                      </div>
                      {loader}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId={10}>
              <Row>
                <Col xl={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">
                        Call Logs{" "}
                        <i>(data available, max last 45 days)</i>
                      </h4>
                      <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0 team-analysis-table">
                          <thead className="table-light">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Staff Name</th>
                              <th scope="col">Total Calls</th>
                              <th scope="col">Incoming</th>
                              <th scope="col">Outgoing</th>
                              <th scope="col">Missed</th>
                              <th scope="col">Not Picked</th>
                              <th scope="col">Total Duration</th>
                              <th scope="col">Avg Duration/Call</th>
                              <th scope="col" className="text-center">
                                Details
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {callLogs && callLogs.length > 0 ? (
                              callLogs.map((log, index) => (
                                <tr
                                  key={log.id}
                                  className="call-log-summary-row"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => openCallHistoryModal(log)}
                                >
                                  <td>
                                    {(callLogsCurrentPage - 1) * 25 + index + 1}
                                  </td>
                                  <td>
                                    <strong>{log.user?.name || "N/A"}</strong>
                                  </td>
                                  <td
                                    onClick={e => {
                                      e.stopPropagation()
                                      openCallHistoryModal(log)
                                    }}
                                    title="View all calls"
                                  >
                                    <span className="badge bg-primary fs-6">
                                      {log.total_calls || 0}
                                    </span>
                                  </td>
                                  <td
                                    onClick={e => {
                                      e.stopPropagation()
                                      openCallHistoryModal(log, "incoming")
                                    }}
                                    title="View incoming calls only"
                                  >
                                    <span className="badge bg-success">
                                      {log.incoming_calls || 0}
                                    </span>
                                  </td>
                                  <td
                                    onClick={e => {
                                      e.stopPropagation()
                                      openCallHistoryModal(log, "outgoing")
                                    }}
                                    title="View outgoing calls only"
                                  >
                                    <span className="badge bg-info">
                                      {log.outgoing_calls || 0}
                                    </span>
                                  </td>
                                  <td
                                    onClick={e => {
                                      e.stopPropagation()
                                      openCallHistoryModal(log, "missed")
                                    }}
                                    title="View missed calls only"
                                  >
                                    <span className="badge bg-warning text-dark">
                                      {log.missed_calls || 0}
                                    </span>
                                  </td>
                                  <td
                                    onClick={e => {
                                      e.stopPropagation()
                                      openCallHistoryModal(log, "not_picked")
                                    }}
                                    title="View not picked calls only"
                                  >
                                    <span className="badge bg-danger">
                                      {log.not_picked_calls || 0}
                                    </span>
                                  </td>
                                  <td>
                                    <strong>
                                      {log.total_duration_formatted ||
                                        "00:00:00"}
                                    </strong>
                                  </td>
                                  <td>
                                    {log.avg_duration_formatted || "00:00:00"}
                                  </td>
                                  <td
                                    className="text-center"
                                    onClick={e => e.stopPropagation()}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => openCallHistoryModal(log)}
                                    >
                                      <i
                                        className="fas fa-list-ul me-1"
                                        aria-hidden="true"
                                      />
                                      History
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center">
                                  {loader ? "" : "No call logs found"}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {loader}
                      {callLogsPages > 1 && (
                        <div className="d-flex justify-content-center mt-3">
                          <Paginations
                            current_page={callLogsCurrentPage}
                            last_page={callLogsPages}
                            onPageChange={page => getCallLogs(page)}
                          />
                        </div>
                      )}
                      <CallLogHistoryDetailModal
                        isOpen={callHistoryDetailOpen}
                        toggle={() => {
                          setCallHistoryDetailOpen(false)
                          setSelectedCallLogRow(null)
                          setCallHistoryDirectionFilter(null)
                        }}
                        summaryLog={selectedCallLogRow}
                        filterStartDate={startdate}
                        filterEndDate={enddate}
                        directionFilter={callHistoryDirectionFilter}
                        onDirectionFilterChange={setCallHistoryDirectionFilter}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
          </TabContent>
          <Modal
            isOpen={filterModal}
            centered={true}
            // size="xl"
            style={{ maxWidth: "600px" }}
          >
            <AvForm
              className="modal-title mt-0"
              id="myModalLabel"
              onValidSubmit={(e, v) => getFilterData(e, v)}
            >
              <div className="modal-header">
                <h5 className="modal-title mt-0" id="myLargeModalLabel">
                  Filter
                </h5>
                <button
                  type="button"
                  className="cross__btn"
                  onClick={() => setFilterModal(false)}
                  aria-hidden="true"
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  {getCurrentUser().role_name == "Executive" ||
                  customActiveTab == "7" || customActiveTab == "8" ? (
                    ""
                  ) : (
                    <div className="mb-3 col-8">
                      <AvField
                        className="select-arrow"
                        label="Lead Holder"
                        type="select"
                        name="leadholder_id"
                      >
                        <option value="" hidden>
                          Select Leadholder
                        </option>
                        {JSON.parse(localStorage.getItem("AllUsers")) &&
                          JSON.parse(localStorage.getItem("AllUsers")).map(
                            (option, i) => (
                              <option value={option.id} key={i}>
                                {option.name}
                              </option>
                            )
                          )}
                      </AvField>
                    </div>
                  )}
                </div>
                <div className="mb-3">
                 <DateRangePicker
  onChange={item => {
    if (customActiveTab === 3) {
      // force single-day selection
      const selectedDate = item.selection.startDate;

      setDateFilter([{
        ...item.selection,
        startDate: selectedDate,
        endDate: selectedDate,
      }]);
    } else {
      setDateFilter([item.selection]);
    }
  }}
  showSelectionPreview={true}
  moveRangeOnFirstSelection={false}
  months={1}
  ranges={dateFilter}
  direction="horizontal"
  minDate={getMinDate()}
  maxDate={new Date()}
/>
                </div>
              </div>
              <div className="modal-footer">
                <div className="text-center d-flex">
                  {loading ? (
                    <button
                      className="btn btn-primary disabled me-2"
                      type="button"
                      disabled
                    >
                      Loading
                    </button>
                  ) : (
                    <button
                      className="btn btn-primary"
                      type="submit"
                      // onClick={() => props.setmodal_standard(false)}
                    >
                      Filter
                    </button>
                  )}
                </div>
              </div>
            </AvForm>
          </Modal>
        </Container>
      </div>
      {getCurrentUser()?.role_name === "Administrator" ||
      getCurrentUser()?.role_name === "Sub Administrator" ? (
        <Modal isOpen={showPopup} toggle={() => setShowPopup(false)}>
          <div className="modal-header">
            <h5 className="modal-title"></h5>
            <button
              type="button"
              className="close"
              onClick={handleNotInterestedClick}
            >
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            Now host this CRM on your domain <strong>FOR FREE</strong>!!!!
          </div>
          <div className="modal-footer">
            <button
              type="submit"
              className="btn bg-success text-white"
              onClick={handleExploreClick}
            >
              Explore
            </button>
            <button
              type="submit"
              className="btn bg-danger text-white"
              onClick={handleNotInterestedClick}
            >
              Not Interested
            </button>
          </div>
        </Modal>
      ) : (
        ""
      )}
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Dashboard)
